unit View.Compras.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.Lists, WEBLib.Grids, Grid.Plugins, UUtils, UConstantes,
  UWeb.Enum, System.StrUtils;

type
  TFViewComprasEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbfornecedores_id: TLabel;
    edfornecedores_id: TDBEdit;
    lbcfop: TLabel;
    edcfop: TDBEdit;
    lbmodelo: TLabel;
    edmodelo: TDBEdit;
    lbserie: TLabel;
    edserie: TDBEdit;
    lbemissao: TLabel;
    edemissao: TDBEdit;
    lbentrada: TLabel;
    edentrada: TDBEdit;
    lbvalor_base_icms: TLabel;
    edvalor_base_icms: TDBEdit;
    lbvalor_icms: TLabel;
    edvalor_icms: TDBEdit;
    lbvalor_icms_desonerado: TLabel;
    edvalor_icms_desonerado: TDBEdit;
    lbvalor_base_st: TLabel;
    edvalor_base_st: TDBEdit;
    lbvalor_st: TLabel;
    edvalor_st: TDBEdit;
    lbvalor_ipi: TLabel;
    edvalor_ipi: TDBEdit;
    lbvalor_pis: TLabel;
    edvalor_pis: TDBEdit;
    lbvalor_cofins: TLabel;
    edvalor_cofins: TDBEdit;
    lbvalor_frete: TLabel;
    edvalor_frete: TDBEdit;
    lbvalor_seguro: TLabel;
    edvalor_seguro: TDBEdit;
    lbvalor_outras: TLabel;
    edvalor_outras: TDBEdit;
    lbacrescimo: TLabel;
    edacrescimo: TDBEdit;
    lbvalor_acrescimo: TLabel;
    edvalor_acrescimo: TDBEdit;
    lbdesconto: TLabel;
    eddesconto: TDBEdit;
    lbvalor_desconto: TLabel;
    edvalor_desconto: TDBEdit;
    lbvalor_itens: TLabel;
    edvalor_itens: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbobs: TLabel;
    edobs: TDBEdit;
    lbchave_nfe: TLabel;
    edchave_nfe: TDBEdit;
    lbicms_compoe_base_pis_confins: TLabel;
    lbipi_compoe_base_pis_cofins: TLabel;
    lbfrete_compoe_base_pis_cofins: TLabel;
    lbseguro_compoe_base_pis_cofins: TLabel;
    lboutras_compoe_base_pis_cofins: TLabel;
    lbplano_contas_id: TLabel;
    edplano_contas_id: TDBEdit;
    lbplano_contas_contabil_id: TLabel;
    edplano_contas_contabil_id: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientComprasGet: TXDataWebClient;
    ComprasDataset: TXDataWebDataSet;
    ComprasDatasetid: TIntegerField;
    ComprasDatasetfornecedores_id: TIntegerField;
    ComprasDatasetcfop: TStringField;
    ComprasDatasetmodelo: TStringField;
    ComprasDatasetserie: TStringField;
    ComprasDatasetemissao: TDateTimeField;
    ComprasDatasetentrada: TDateTimeField;
    ComprasDatasetvalor_base_icms: TFloatField;
    ComprasDatasetvalor_icms: TFloatField;
    ComprasDatasetvalor_icms_desonerado: TFloatField;
    ComprasDatasetvalor_base_st: TFloatField;
    ComprasDatasetvalor_st: TFloatField;
    ComprasDatasetvalor_ipi: TFloatField;
    ComprasDatasetvalor_pis: TFloatField;
    ComprasDatasetvalor_cofins: TFloatField;
    ComprasDatasetvalor_frete: TFloatField;
    ComprasDatasetvalor_seguro: TFloatField;
    ComprasDatasetvalor_outras: TFloatField;
    ComprasDatasetacrescimo: TFloatField;
    ComprasDatasetvalor_acrescimo: TFloatField;
    ComprasDatasetdesconto: TFloatField;
    ComprasDatasetvalor_desconto: TFloatField;
    ComprasDatasetvalor_itens: TFloatField;
    ComprasDatasetvalor_total: TFloatField;
    ComprasDatasetobs: TStringField;
    ComprasDatasetchave_nfe: TStringField;
    ComprasDataseticms_compoe_base_pis_confins: TBooleanField;
    ComprasDatasetipi_compoe_base_pis_cofins: TBooleanField;
    ComprasDatasetfrete_compoe_base_pis_cofins: TBooleanField;
    ComprasDatasetseguro_compoe_base_pis_cofins: TBooleanField;
    ComprasDatasetoutras_compoe_base_pis_cofins: TBooleanField;
    ComprasDatasetplano_contas_id: TIntegerField;
    ComprasDatasetplano_contas_contabil_id: TIntegerField;
    ComprasDatasetcodigo_interno: TIntegerField;
    ComprasDatasetexcluido: TBooleanField;
    ComprasDatasetinclusao: TDateTimeField;
    ComprasDatasetalteracao: TDateTimeField;
    ComprasDatasetexclusao: TDateTimeField;
    ComprasDatasetcfop_cfopnome: TStringField;
    ComprasDatasetplano_contanome: TStringField;
    ComprasDatasetplano_conta_contnome: TStringField;
    cbxexcluido: TDBCheckBox;
    cbxicms_compoe_base_pis_confins: TDBCheckBox;
    cbxipi_compoe_base_pis_cofins: TDBCheckBox;
    cbxfrete_compoe_base_pis_cofins: TDBCheckBox;
    cbxseguro_compoe_base_pis_cofins: TDBCheckBox;
    cbxoutras_compoe_base_pis_cofins: TDBCheckBox;
    ComprasDatasetfornecedorrazao_social_nome: TStringField;
    btnCopiarChaveAcesso: TButton;
    lbPaginationInfoItens: TLabel;
    tblItens: TDBTableControl;
    cbPageSizeItens: TComboBox;
    edSearchItens: TEdit;
    pnlItensPromocao: TPanel;
    btnItensTab: TButton;
    lcPaginatorItens: TListControl;
    cdsItens: TXDataWebDataSet;
    dtsItens: TDataSource;
    tmrConsultaItens: TTimer;
    cdsItensitem: TIntegerField;
    cdsItensproduto_nome: TStringField;
    cdsItensquantidade: TFloatField;
    cdsItensvalor_unitario: TFloatField;
    cdsItensvalor_total: TFloatField;
    cdsItensprodcodigo_interno: TIntegerField;
    cdsItensunidadesigla: TStringField;
    lbPaginationInfoAPagar: TLabel;
    lbPaginationInfoPagamentos: TLabel;
    pnlTabelaAReceber: TPanel;
    tblAPagar: TDBTableControl;
    lcPaginatorAPagar: TListControl;
    tblPagamentos: TDBTableControl;
    pnlTabelaPagamentos: TPanel;
    btnFinanceiroTab: TButton;
    btnPagamentosTab: TButton;
    lcPaginatorPagamentos: TListControl;
    cdsPagamentos: TXDataWebDataSet;
    dtsPagamentos: TDataSource;
    dtsAPagar: TDataSource;
    cdsAPagar: TXDataWebDataSet;
    cdsAPagardocumento: TStringField;
    cdsAPagarvalor: TFloatField;
    cdsAPagarsaldo: TFloatField;
    cdsAPagarpago: TFloatField;
    cdsAPagaremissao: TDateTimeField;
    cdsAPagarvencimento: TDateTimeField;
    cdsAPagarparcela: TStringField;
    cdsPagamentosvalor: TFloatField;
    cdsPagamentosdata: TDateTimeField;
    cdsPagamentosmodalidadenome: TStringField;
    cdsPagamentosapagardocumento: TXDataWebDatasetField;
    cdsPagamentosapagarparcela: TXDataWebDatasetField;
    cdsItensprodnome: TStringField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientComprasGetLoad(Response: TXDataClientResponse);
    procedure ComprasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure ComprasDatasetcfopGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebFormShow(Sender: TObject);
    procedure btnCopiarChaveAcessoClick(Sender: TObject);
    procedure ComprasDatasetAfterOpen(DataSet: TDataSet);
    procedure btnItensTabClick(Sender: TObject);
    procedure cbPageSizeItensChange(Sender: TObject);
    procedure edSearchItensKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchItensKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaItensTimer(Sender: TObject);
    procedure cdsItensitemGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure tblItensGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cdsAPagardocumentoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnFinanceiroTabClick(Sender: TObject);
    procedure tblAPagarGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblAPagarGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblPagamentosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure btnPagamentosTabClick(Sender: TObject);
    procedure cdsPagamentosapagardocumentoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure cdsItensproduto_nomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginItens,
    FGridPluginAPagar,
    FGridPluginPagamentos : TGridPlugin;

    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure ConfigurarPermissoes;
    procedure CarregarAPagar;
    procedure CarregarPagamentos;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewComprasEdit: TFViewComprasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewComprasEdit }

class function TFViewComprasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewComprasEdit.edSearchItensKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaItens.Enabled := False;

  if Key = 13 then
    FGridPluginItens.SetFilterText(edSearchItens.Text, True);
end;

procedure TFViewComprasEdit.edSearchItensKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaItens.Interval := FTimerConsulta;
  tmrConsultaItens.Enabled := True;
end;

procedure TFViewComprasEdit.InsertEntity;
begin
  ComprasDataset.Close;
  ComprasDataset.SetJsonData('{}');
  ComprasDataset.Open;
  ComprasDataset.Insert;
end;

class function TFViewComprasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewComprasEdit(AForm).FInserting := AInserting;
    TFViewComprasEdit(AForm).FId := AId;
    TFViewComprasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewComprasEdit(AForm).InsertEntity
    else
      TFViewComprasEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewComprasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewComprasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ComprasDataset.Connection.Model.DefaultSchema.FindEntityType(
      ComprasDataset.EntitySetName
    )
  );
  XDataClientComprasGet.Get(ComprasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewComprasEdit.tblAPagarGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAPagar.Columns[ACol].DataField, ['valor', 'saldo',
      'pago', 'documento']) of
      0, 1, 2: AClassName := 'text-end';
      3: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewComprasEdit.tblAPagarGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
var
  lTituloVencido : Boolean;
begin
  if ARow > 0 then
  begin
    lTituloVencido := (tblAPagar.DataSource.DataSet.FieldByName('saldo').AsFloat > 0) and
      (StrToDate(tblAPagar.DataSource.DataSet.FieldByName('vencimento').AsString) < Date);

    if lTituloVencido then
      AValue := '<p class="text-danger">' + AValue + '</p>'
  end;
end;

procedure TFViewComprasEdit.tblItensGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblItens.Columns[ACol].DataField, ['produto_nome', 'quantidade',
     'valor_unitario', 'valor_total']) of
      0: AClassName := 'text-start';
      1, 2, 3: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewComprasEdit.tblPagamentosGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if cdsPagamentos.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblPagamentos.Columns[ACol].DataField, ['valor', 'modalidade.nome',
      'apagar.documento']) of
      0: AClassName := 'text-end';
      1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewComprasEdit.tmrConsultaItensTimer(Sender: TObject);
begin
  FGridPluginItens.SetFilterText(edSearchItens.Text, True);

  tmrConsultaItens.Enabled := False;
  tmrConsultaItens.Interval := FTimerConsulta;
end;

procedure TFViewComprasEdit.WebFormShow(Sender: TObject);
begin
  ConfigurarPermissoes;
end;

procedure TFViewComprasEdit.XDataClientComprasGetLoad(Response: TXDataClientResponse);
begin
  ComprasDataset.Close;
  ComprasDataset.SetJsonData(Response.Result);
  ComprasDataset.Open;
  
  ComprasDataset.Edit;  
end;

procedure TFViewComprasEdit.btnCopiarChaveAcessoClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave de acesso copiada com sucesso!', 'Cópia de chave de acesso',
    edchave_nfe.Text);
end;

procedure TFViewComprasEdit.btnFinanceiroTabClick(Sender: TObject);
begin
  if TUtils.PossuiPermissao(cdsAPagar.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
    CarregarAPagar
  else
  begin
    TUtils.SelecionarTab('#line-pagamentos-tab');
    CarregarPagamentos;
  end;
end;

procedure TFViewComprasEdit.btnItensTabClick(Sender: TObject);
begin
  if cdsItens.Tag = 0 then
  begin
    cdsItens.Tag := 1;

    FGridPluginItens := TGridPlugin.Create(tblItens, cdsItens, lcPaginatorItens, lbPaginationInfoItens);
    FGridPluginItens.FDatasetPlugin.FFilterPadrao := '(compra_id eq ' + edid.Text +')';
    FGridPluginItens.FDatasetPlugin.FOrderByPadrao := 'item asc';
    FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text));
    FGridPluginItens.SetFilterText(edSearchItens.Text);
    FGridPluginItens.Load;
  end;
end;

procedure TFViewComprasEdit.btnPagamentosTabClick(Sender: TObject);
begin
  CarregarPagamentos;
end;

procedure TFViewComprasEdit.CarregarAPagar;
begin
  if cdsAPagar.Tag = 0 then
  begin
    cdsAPagar.Tag := 1;

    FGridPluginAPagar := TGridPlugin.Create(tblAPagar, cdsAPagar, lcPaginatorAPagar,
      lbPaginationInfoAPagar);
    FGridPluginAPagar.FDatasetPlugin.FFilterPadrao := '(compra_id eq ' + edid.Text +')';
    FGridPluginAPagar.FDatasetPlugin.FOrderByPadrao := 'vencimento asc';
    FGridPluginAPagar.SetPageSize(10);
    FGridPluginAPagar.SetFilterText(EmptyStr);
    FGridPluginAPagar.Load;
  end;
end;

procedure TFViewComprasEdit.CarregarPagamentos;
begin
  if cdsPagamentos.Tag = 0 then
  begin
    cdsPagamentos.Tag := 1;

    FGridPluginPagamentos := TGridPlugin.Create(tblPagamentos, cdsPagamentos, lcPaginatorPagamentos,
      lbPaginationInfoPagamentos);
    FGridPluginPagamentos.FDatasetPlugin.FFilterPadrao := '(apagar/compra_id eq ' + edid.Text +')';
    FGridPluginPagamentos.FDatasetPlugin.FOrderByPadrao := 'data desc, codigo_interno desc';
    FGridPluginPagamentos.SetPageSize(10);
    FGridPluginPagamentos.SetFilterText(EmptyStr);
    FGridPluginPagamentos.Load;
  end;
end;

procedure TFViewComprasEdit.cbPageSizeItensChange(Sender: TObject);
begin
  FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text), True);
end;

procedure TFViewComprasEdit.cdsAPagardocumentoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarDocumento(Sender.AsString, cdsAPagar.FieldByName('parcela').AsInteger);
end;

procedure TFViewComprasEdit.cdsItensitemGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := Format('%.3d', [Sender.AsInteger]);
end;

procedure TFViewComprasEdit.cdsItensproduto_nomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Text := cdsItens.FieldByName('prod.nome').AsString
  else
    Text := Sender.AsString;
end;

procedure TFViewComprasEdit.cdsPagamentosapagardocumentoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarDocumento(Sender.AsString, cdsPagamentos.FieldByName('apagar.parcela').AsInteger);
end;

procedure TFViewComprasEdit.ComprasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewComprasEdit.ComprasDatasetAfterOpen(DataSet: TDataSet);
begin
  if edchave_nfe.Text = '' then
    btnCopiarChaveAcesso.Enabled := False;
end;

procedure TFViewComprasEdit.ComprasDatasetcfopGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  Text := Sender.AsString + ' - ' + ComprasDataset.FieldByName('cfop_cfop.nome').AsString;
end;

procedure TFViewComprasEdit.ConfigurarPermissoes;
begin
  if not TUtils.PossuiPermissao(cdsItens.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-itens-tab');
    TUtils.RemoverElementoPorId('line-itens');
  end;

  if not TUtils.PossuiPermissao(cdsAPagar.EntitySetName.ToLower, TTipoPermissao.Visualizar) and
    not TUtils.PossuiPermissao(cdsPagamentos.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-financeiro-tab');
    TUtils.RemoverElementoPorId('line-financeiro');
  end
  else if not TUtils.PossuiPermissao(cdsAPagar.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-apagar-tab');
    TUtils.RemoverElementoPorId('line-apagar');
  end
  else if not TUtils.PossuiPermissao(cdsPagamentos.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-pagamentos-tab');
    TUtils.RemoverElementoPorId('line-pagamentos');
  end;
end;

procedure TFViewComprasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewComprasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.compras.form.lbid');
  lbfornecedores_id := TLabel.Create('view.compras.form.lbfornecedores_id');
  lbcfop := TLabel.Create('view.compras.form.lbcfop');
  lbmodelo := TLabel.Create('view.compras.form.lbmodelo');
  lbserie := TLabel.Create('view.compras.form.lbserie');
  lbemissao := TLabel.Create('view.compras.form.lbemissao');
  lbentrada := TLabel.Create('view.compras.form.lbentrada');
  lbvalor_base_icms := TLabel.Create('view.compras.form.lbvalor_base_icms');
  lbvalor_icms := TLabel.Create('view.compras.form.lbvalor_icms');
  lbvalor_icms_desonerado := TLabel.Create('view.compras.form.lbvalor_icms_desonerado');
  lbvalor_base_st := TLabel.Create('view.compras.form.lbvalor_base_st');
  lbvalor_st := TLabel.Create('view.compras.form.lbvalor_st');
  lbvalor_ipi := TLabel.Create('view.compras.form.lbvalor_ipi');
  lbvalor_pis := TLabel.Create('view.compras.form.lbvalor_pis');
  lbvalor_cofins := TLabel.Create('view.compras.form.lbvalor_cofins');
  lbvalor_frete := TLabel.Create('view.compras.form.lbvalor_frete');
  lbvalor_seguro := TLabel.Create('view.compras.form.lbvalor_seguro');
  lbvalor_outras := TLabel.Create('view.compras.form.lbvalor_outras');
  lbacrescimo := TLabel.Create('view.compras.form.lbacrescimo');
  lbvalor_acrescimo := TLabel.Create('view.compras.form.lbvalor_acrescimo');
  lbdesconto := TLabel.Create('view.compras.form.lbdesconto');
  lbvalor_desconto := TLabel.Create('view.compras.form.lbvalor_desconto');
  lbvalor_itens := TLabel.Create('view.compras.form.lbvalor_itens');
  lbvalor_total := TLabel.Create('view.compras.form.lbvalor_total');
  lbobs := TLabel.Create('view.compras.form.lbobs');
  lbchave_nfe := TLabel.Create('view.compras.form.lbchave_nfe');
  lbicms_compoe_base_pis_confins := TLabel.Create('view.compras.form.lbicms_compoe_base_pis_confins');
  lbipi_compoe_base_pis_cofins := TLabel.Create('view.compras.form.lbipi_compoe_base_pis_cofins');
  lbfrete_compoe_base_pis_cofins := TLabel.Create('view.compras.form.lbfrete_compoe_base_pis_cofins');
  lbseguro_compoe_base_pis_cofins := TLabel.Create('view.compras.form.lbseguro_compoe_base_pis_cofins');
  lboutras_compoe_base_pis_cofins := TLabel.Create('view.compras.form.lboutras_compoe_base_pis_cofins');
  lbplano_contas_id := TLabel.Create('view.compras.form.lbplano_contas_id');
  lbplano_contas_contabil_id := TLabel.Create('view.compras.form.lbplano_contas_contabil_id');
  lbcodigo_interno := TLabel.Create('view.compras.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.compras.form.lbexcluido');
  lbinclusao := TLabel.Create('view.compras.form.lbinclusao');
  lbalteracao := TLabel.Create('view.compras.form.lbalteracao');
  lbexclusao := TLabel.Create('view.compras.form.lbexclusao');
  lbPaginationInfoItens := TLabel.Create('lbPaginationInfoItens');
  lbPaginationInfoAPagar := TLabel.Create('lbPaginationInfoAPagar');
  lbPaginationInfoPagamentos := TLabel.Create('lbPaginationInfoPagamentos');
  btCancel := TButton.Create('view.compras.form.btBack');
  edid := TDBEdit.Create('view.compras.form.edid');
  edfornecedores_id := TDBEdit.Create('view.compras.form.edfornecedores_id');
  edcfop := TDBEdit.Create('view.compras.form.edcfop');
  edmodelo := TDBEdit.Create('view.compras.form.edmodelo');
  edserie := TDBEdit.Create('view.compras.form.edserie');
  edemissao := TDBEdit.Create('view.compras.form.edemissao');
  edentrada := TDBEdit.Create('view.compras.form.edentrada');
  edvalor_base_icms := TDBEdit.Create('view.compras.form.edvalor_base_icms');
  edvalor_icms := TDBEdit.Create('view.compras.form.edvalor_icms');
  edvalor_icms_desonerado := TDBEdit.Create('view.compras.form.edvalor_icms_desonerado');
  edvalor_base_st := TDBEdit.Create('view.compras.form.edvalor_base_st');
  edvalor_st := TDBEdit.Create('view.compras.form.edvalor_st');
  edvalor_ipi := TDBEdit.Create('view.compras.form.edvalor_ipi');
  edvalor_pis := TDBEdit.Create('view.compras.form.edvalor_pis');
  edvalor_cofins := TDBEdit.Create('view.compras.form.edvalor_cofins');
  edvalor_frete := TDBEdit.Create('view.compras.form.edvalor_frete');
  edvalor_seguro := TDBEdit.Create('view.compras.form.edvalor_seguro');
  edvalor_outras := TDBEdit.Create('view.compras.form.edvalor_outras');
  edacrescimo := TDBEdit.Create('view.compras.form.edacrescimo');
  edvalor_acrescimo := TDBEdit.Create('view.compras.form.edvalor_acrescimo');
  eddesconto := TDBEdit.Create('view.compras.form.eddesconto');
  edvalor_desconto := TDBEdit.Create('view.compras.form.edvalor_desconto');
  edvalor_itens := TDBEdit.Create('view.compras.form.edvalor_itens');
  edvalor_total := TDBEdit.Create('view.compras.form.edvalor_total');
  edobs := TDBEdit.Create('view.compras.form.edobs');
  edchave_nfe := TDBEdit.Create('view.compras.form.edchave_nfe');
  edplano_contas_id := TDBEdit.Create('view.compras.form.edplano_contas_id');
  edplano_contas_contabil_id := TDBEdit.Create('view.compras.form.edplano_contas_contabil_id');
  edcodigo_interno := TDBEdit.Create('view.compras.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.compras.form.edinclusao');
  edalteracao := TDBEdit.Create('view.compras.form.edalteracao');
  edexclusao := TDBEdit.Create('view.compras.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.compras.form.cbxexcluido');
  cbxicms_compoe_base_pis_confins := TDBCheckBox.Create('view.compras.form.cbxicms_compoe_base_pis_confins');
  cbxipi_compoe_base_pis_cofins := TDBCheckBox.Create('view.compras.form.cbxipi_compoe_base_pis_cofins');
  cbxfrete_compoe_base_pis_cofins := TDBCheckBox.Create('view.compras.form.cbxfrete_compoe_base_pis_cofins');
  cbxseguro_compoe_base_pis_cofins := TDBCheckBox.Create('view.compras.form.cbxseguro_compoe_base_pis_cofins');
  cbxoutras_compoe_base_pis_cofins := TDBCheckBox.Create('view.compras.form.cbxoutras_compoe_base_pis_cofins');
  btnCopiarChaveAcesso := TButton.Create('btnCopiarChaveAcesso');
  tblItens := TDBTableControl.Create('tblItens');
  cbPageSizeItens := TComboBox.Create('cbPageSizeItens');
  edSearchItens := TEdit.Create('edSearchItens');
  pnlItensPromocao := TPanel.Create(Self);
  btnItensTab := TButton.Create('line-itens-tab');
  lcPaginatorItens := TListControl.Create('lcPaginatorItens');
  pnlTabelaAReceber := TPanel.Create(Self);
  tblAPagar := TDBTableControl.Create('tblAPagar');
  lcPaginatorAPagar := TListControl.Create('lcPaginatorAPagar');
  tblPagamentos := TDBTableControl.Create('tblPagamentos');
  pnlTabelaPagamentos := TPanel.Create(Self);
  btnFinanceiroTab := TButton.Create('line-financeiro-tab');
  btnPagamentosTab := TButton.Create('line-pagamentos-tab');
  lcPaginatorPagamentos := TListControl.Create('lcPaginatorPagamentos');
  DataSource := TDataSource.Create(Self);
  ComprasDataset := TXDataWebDataSet.Create(Self);
  ComprasDatasetid := TIntegerField.Create(Self);
  ComprasDatasetfornecedores_id := TIntegerField.Create(Self);
  ComprasDatasetcfop := TStringField.Create(Self);
  ComprasDatasetmodelo := TStringField.Create(Self);
  ComprasDatasetserie := TStringField.Create(Self);
  ComprasDatasetemissao := TDateTimeField.Create(Self);
  ComprasDatasetentrada := TDateTimeField.Create(Self);
  ComprasDatasetvalor_base_icms := TFloatField.Create(Self);
  ComprasDatasetvalor_icms := TFloatField.Create(Self);
  ComprasDatasetvalor_icms_desonerado := TFloatField.Create(Self);
  ComprasDatasetvalor_base_st := TFloatField.Create(Self);
  ComprasDatasetvalor_st := TFloatField.Create(Self);
  ComprasDatasetvalor_ipi := TFloatField.Create(Self);
  ComprasDatasetvalor_pis := TFloatField.Create(Self);
  ComprasDatasetvalor_cofins := TFloatField.Create(Self);
  ComprasDatasetvalor_frete := TFloatField.Create(Self);
  ComprasDatasetvalor_seguro := TFloatField.Create(Self);
  ComprasDatasetvalor_outras := TFloatField.Create(Self);
  ComprasDatasetacrescimo := TFloatField.Create(Self);
  ComprasDatasetvalor_acrescimo := TFloatField.Create(Self);
  ComprasDatasetdesconto := TFloatField.Create(Self);
  ComprasDatasetvalor_desconto := TFloatField.Create(Self);
  ComprasDatasetvalor_itens := TFloatField.Create(Self);
  ComprasDatasetvalor_total := TFloatField.Create(Self);
  ComprasDatasetobs := TStringField.Create(Self);
  ComprasDatasetchave_nfe := TStringField.Create(Self);
  ComprasDataseticms_compoe_base_pis_confins := TBooleanField.Create(Self);
  ComprasDatasetipi_compoe_base_pis_cofins := TBooleanField.Create(Self);
  ComprasDatasetfrete_compoe_base_pis_cofins := TBooleanField.Create(Self);
  ComprasDatasetseguro_compoe_base_pis_cofins := TBooleanField.Create(Self);
  ComprasDatasetoutras_compoe_base_pis_cofins := TBooleanField.Create(Self);
  ComprasDatasetplano_contas_id := TIntegerField.Create(Self);
  ComprasDatasetplano_contas_contabil_id := TIntegerField.Create(Self);
  ComprasDatasetcodigo_interno := TIntegerField.Create(Self);
  ComprasDatasetexcluido := TBooleanField.Create(Self);
  ComprasDatasetinclusao := TDateTimeField.Create(Self);
  ComprasDatasetalteracao := TDateTimeField.Create(Self);
  ComprasDatasetexclusao := TDateTimeField.Create(Self);
  ComprasDatasetcfop_cfopnome := TStringField.Create(Self);
  ComprasDatasetplano_contanome := TStringField.Create(Self);
  ComprasDatasetplano_conta_contnome := TStringField.Create(Self);
  ComprasDatasetfornecedorrazao_social_nome := TStringField.Create(Self);
  XDataClientComprasGet := TXDataWebClient.Create(Self);
  cdsItens := TXDataWebDataSet.Create(Self);
  cdsItensitem := TIntegerField.Create(Self);
  cdsItensproduto_nome := TStringField.Create(Self);
  cdsItensquantidade := TFloatField.Create(Self);
  cdsItensvalor_unitario := TFloatField.Create(Self);
  cdsItensvalor_total := TFloatField.Create(Self);
  cdsItensprodcodigo_interno := TIntegerField.Create(Self);
  cdsItensunidadesigla := TStringField.Create(Self);
  cdsItensprodnome := TStringField.Create(Self);
  dtsItens := TDataSource.Create(Self);
  tmrConsultaItens := TTimer.Create(Self);
  cdsPagamentos := TXDataWebDataSet.Create(Self);
  cdsPagamentosvalor := TFloatField.Create(Self);
  cdsPagamentosdata := TDateTimeField.Create(Self);
  cdsPagamentosmodalidadenome := TStringField.Create(Self);
  cdsPagamentosapagardocumento := TXDataWebDatasetField.Create(Self);
  cdsPagamentosapagarparcela := TXDataWebDatasetField.Create(Self);
  dtsPagamentos := TDataSource.Create(Self);
  dtsAPagar := TDataSource.Create(Self);
  cdsAPagar := TXDataWebDataSet.Create(Self);
  cdsAPagardocumento := TStringField.Create(Self);
  cdsAPagarvalor := TFloatField.Create(Self);
  cdsAPagarsaldo := TFloatField.Create(Self);
  cdsAPagarpago := TFloatField.Create(Self);
  cdsAPagaremissao := TDateTimeField.Create(Self);
  cdsAPagarvencimento := TDateTimeField.Create(Self);
  cdsAPagarparcela := TStringField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbfornecedores_id.BeforeLoadDFMValues;
  lbcfop.BeforeLoadDFMValues;
  lbmodelo.BeforeLoadDFMValues;
  lbserie.BeforeLoadDFMValues;
  lbemissao.BeforeLoadDFMValues;
  lbentrada.BeforeLoadDFMValues;
  lbvalor_base_icms.BeforeLoadDFMValues;
  lbvalor_icms.BeforeLoadDFMValues;
  lbvalor_icms_desonerado.BeforeLoadDFMValues;
  lbvalor_base_st.BeforeLoadDFMValues;
  lbvalor_st.BeforeLoadDFMValues;
  lbvalor_ipi.BeforeLoadDFMValues;
  lbvalor_pis.BeforeLoadDFMValues;
  lbvalor_cofins.BeforeLoadDFMValues;
  lbvalor_frete.BeforeLoadDFMValues;
  lbvalor_seguro.BeforeLoadDFMValues;
  lbvalor_outras.BeforeLoadDFMValues;
  lbacrescimo.BeforeLoadDFMValues;
  lbvalor_acrescimo.BeforeLoadDFMValues;
  lbdesconto.BeforeLoadDFMValues;
  lbvalor_desconto.BeforeLoadDFMValues;
  lbvalor_itens.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  lbobs.BeforeLoadDFMValues;
  lbchave_nfe.BeforeLoadDFMValues;
  lbicms_compoe_base_pis_confins.BeforeLoadDFMValues;
  lbipi_compoe_base_pis_cofins.BeforeLoadDFMValues;
  lbfrete_compoe_base_pis_cofins.BeforeLoadDFMValues;
  lbseguro_compoe_base_pis_cofins.BeforeLoadDFMValues;
  lboutras_compoe_base_pis_cofins.BeforeLoadDFMValues;
  lbplano_contas_id.BeforeLoadDFMValues;
  lbplano_contas_contabil_id.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbPaginationInfoItens.BeforeLoadDFMValues;
  lbPaginationInfoAPagar.BeforeLoadDFMValues;
  lbPaginationInfoPagamentos.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edfornecedores_id.BeforeLoadDFMValues;
  edcfop.BeforeLoadDFMValues;
  edmodelo.BeforeLoadDFMValues;
  edserie.BeforeLoadDFMValues;
  edemissao.BeforeLoadDFMValues;
  edentrada.BeforeLoadDFMValues;
  edvalor_base_icms.BeforeLoadDFMValues;
  edvalor_icms.BeforeLoadDFMValues;
  edvalor_icms_desonerado.BeforeLoadDFMValues;
  edvalor_base_st.BeforeLoadDFMValues;
  edvalor_st.BeforeLoadDFMValues;
  edvalor_ipi.BeforeLoadDFMValues;
  edvalor_pis.BeforeLoadDFMValues;
  edvalor_cofins.BeforeLoadDFMValues;
  edvalor_frete.BeforeLoadDFMValues;
  edvalor_seguro.BeforeLoadDFMValues;
  edvalor_outras.BeforeLoadDFMValues;
  edacrescimo.BeforeLoadDFMValues;
  edvalor_acrescimo.BeforeLoadDFMValues;
  eddesconto.BeforeLoadDFMValues;
  edvalor_desconto.BeforeLoadDFMValues;
  edvalor_itens.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  edobs.BeforeLoadDFMValues;
  edchave_nfe.BeforeLoadDFMValues;
  edplano_contas_id.BeforeLoadDFMValues;
  edplano_contas_contabil_id.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxicms_compoe_base_pis_confins.BeforeLoadDFMValues;
  cbxipi_compoe_base_pis_cofins.BeforeLoadDFMValues;
  cbxfrete_compoe_base_pis_cofins.BeforeLoadDFMValues;
  cbxseguro_compoe_base_pis_cofins.BeforeLoadDFMValues;
  cbxoutras_compoe_base_pis_cofins.BeforeLoadDFMValues;
  btnCopiarChaveAcesso.BeforeLoadDFMValues;
  tblItens.BeforeLoadDFMValues;
  cbPageSizeItens.BeforeLoadDFMValues;
  edSearchItens.BeforeLoadDFMValues;
  pnlItensPromocao.BeforeLoadDFMValues;
  btnItensTab.BeforeLoadDFMValues;
  lcPaginatorItens.BeforeLoadDFMValues;
  pnlTabelaAReceber.BeforeLoadDFMValues;
  tblAPagar.BeforeLoadDFMValues;
  lcPaginatorAPagar.BeforeLoadDFMValues;
  tblPagamentos.BeforeLoadDFMValues;
  pnlTabelaPagamentos.BeforeLoadDFMValues;
  btnFinanceiroTab.BeforeLoadDFMValues;
  btnPagamentosTab.BeforeLoadDFMValues;
  lcPaginatorPagamentos.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ComprasDataset.BeforeLoadDFMValues;
  ComprasDatasetid.BeforeLoadDFMValues;
  ComprasDatasetfornecedores_id.BeforeLoadDFMValues;
  ComprasDatasetcfop.BeforeLoadDFMValues;
  ComprasDatasetmodelo.BeforeLoadDFMValues;
  ComprasDatasetserie.BeforeLoadDFMValues;
  ComprasDatasetemissao.BeforeLoadDFMValues;
  ComprasDatasetentrada.BeforeLoadDFMValues;
  ComprasDatasetvalor_base_icms.BeforeLoadDFMValues;
  ComprasDatasetvalor_icms.BeforeLoadDFMValues;
  ComprasDatasetvalor_icms_desonerado.BeforeLoadDFMValues;
  ComprasDatasetvalor_base_st.BeforeLoadDFMValues;
  ComprasDatasetvalor_st.BeforeLoadDFMValues;
  ComprasDatasetvalor_ipi.BeforeLoadDFMValues;
  ComprasDatasetvalor_pis.BeforeLoadDFMValues;
  ComprasDatasetvalor_cofins.BeforeLoadDFMValues;
  ComprasDatasetvalor_frete.BeforeLoadDFMValues;
  ComprasDatasetvalor_seguro.BeforeLoadDFMValues;
  ComprasDatasetvalor_outras.BeforeLoadDFMValues;
  ComprasDatasetacrescimo.BeforeLoadDFMValues;
  ComprasDatasetvalor_acrescimo.BeforeLoadDFMValues;
  ComprasDatasetdesconto.BeforeLoadDFMValues;
  ComprasDatasetvalor_desconto.BeforeLoadDFMValues;
  ComprasDatasetvalor_itens.BeforeLoadDFMValues;
  ComprasDatasetvalor_total.BeforeLoadDFMValues;
  ComprasDatasetobs.BeforeLoadDFMValues;
  ComprasDatasetchave_nfe.BeforeLoadDFMValues;
  ComprasDataseticms_compoe_base_pis_confins.BeforeLoadDFMValues;
  ComprasDatasetipi_compoe_base_pis_cofins.BeforeLoadDFMValues;
  ComprasDatasetfrete_compoe_base_pis_cofins.BeforeLoadDFMValues;
  ComprasDatasetseguro_compoe_base_pis_cofins.BeforeLoadDFMValues;
  ComprasDatasetoutras_compoe_base_pis_cofins.BeforeLoadDFMValues;
  ComprasDatasetplano_contas_id.BeforeLoadDFMValues;
  ComprasDatasetplano_contas_contabil_id.BeforeLoadDFMValues;
  ComprasDatasetcodigo_interno.BeforeLoadDFMValues;
  ComprasDatasetexcluido.BeforeLoadDFMValues;
  ComprasDatasetinclusao.BeforeLoadDFMValues;
  ComprasDatasetalteracao.BeforeLoadDFMValues;
  ComprasDatasetexclusao.BeforeLoadDFMValues;
  ComprasDatasetcfop_cfopnome.BeforeLoadDFMValues;
  ComprasDatasetplano_contanome.BeforeLoadDFMValues;
  ComprasDatasetplano_conta_contnome.BeforeLoadDFMValues;
  ComprasDatasetfornecedorrazao_social_nome.BeforeLoadDFMValues;
  XDataClientComprasGet.BeforeLoadDFMValues;
  cdsItens.BeforeLoadDFMValues;
  cdsItensitem.BeforeLoadDFMValues;
  cdsItensproduto_nome.BeforeLoadDFMValues;
  cdsItensquantidade.BeforeLoadDFMValues;
  cdsItensvalor_unitario.BeforeLoadDFMValues;
  cdsItensvalor_total.BeforeLoadDFMValues;
  cdsItensprodcodigo_interno.BeforeLoadDFMValues;
  cdsItensunidadesigla.BeforeLoadDFMValues;
  cdsItensprodnome.BeforeLoadDFMValues;
  dtsItens.BeforeLoadDFMValues;
  tmrConsultaItens.BeforeLoadDFMValues;
  cdsPagamentos.BeforeLoadDFMValues;
  cdsPagamentosvalor.BeforeLoadDFMValues;
  cdsPagamentosdata.BeforeLoadDFMValues;
  cdsPagamentosmodalidadenome.BeforeLoadDFMValues;
  cdsPagamentosapagardocumento.BeforeLoadDFMValues;
  cdsPagamentosapagarparcela.BeforeLoadDFMValues;
  dtsPagamentos.BeforeLoadDFMValues;
  dtsAPagar.BeforeLoadDFMValues;
  cdsAPagar.BeforeLoadDFMValues;
  cdsAPagardocumento.BeforeLoadDFMValues;
  cdsAPagarvalor.BeforeLoadDFMValues;
  cdsAPagarsaldo.BeforeLoadDFMValues;
  cdsAPagarpago.BeforeLoadDFMValues;
  cdsAPagaremissao.BeforeLoadDFMValues;
  cdsAPagarvencimento.BeforeLoadDFMValues;
  cdsAPagarparcela.BeforeLoadDFMValues;
  try
    Name := 'FViewComprasEdit';
    Width := 827;
    Height := 619;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 8;
    lbid.Width := 70;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Servidor:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbfornecedores_id.SetParentComponent(Self);
    lbfornecedores_id.Name := 'lbfornecedores_id';
    lbfornecedores_id.Left := 8;
    lbfornecedores_id.Top := 36;
    lbfornecedores_id.Width := 59;
    lbfornecedores_id.Height := 13;
    lbfornecedores_id.Caption := 'Fornecedor:';
    lbfornecedores_id.HeightPercent := 100.000000000000000000;
    lbfornecedores_id.WidthPercent := 100.000000000000000000;
    lbcfop.SetParentComponent(Self);
    lbcfop.Name := 'lbcfop';
    lbcfop.Left := 8;
    lbcfop.Top := 63;
    lbcfop.Width := 31;
    lbcfop.Height := 13;
    lbcfop.Caption := 'CFOP:';
    lbcfop.HeightPercent := 100.000000000000000000;
    lbcfop.WidthPercent := 100.000000000000000000;
    lbmodelo.SetParentComponent(Self);
    lbmodelo.Name := 'lbmodelo';
    lbmodelo.Left := 8;
    lbmodelo.Top := 90;
    lbmodelo.Width := 38;
    lbmodelo.Height := 13;
    lbmodelo.Caption := 'Modelo:';
    lbmodelo.HeightPercent := 100.000000000000000000;
    lbmodelo.WidthPercent := 100.000000000000000000;
    lbserie.SetParentComponent(Self);
    lbserie.Name := 'lbserie';
    lbserie.Left := 8;
    lbserie.Top := 117;
    lbserie.Width := 28;
    lbserie.Height := 13;
    lbserie.Caption := 'S'#233'rie:';
    lbserie.HeightPercent := 100.000000000000000000;
    lbserie.WidthPercent := 100.000000000000000000;
    lbemissao.SetParentComponent(Self);
    lbemissao.Name := 'lbemissao';
    lbemissao.Left := 8;
    lbemissao.Top := 144;
    lbemissao.Width := 42;
    lbemissao.Height := 13;
    lbemissao.Caption := 'Emiss'#227'o:';
    lbemissao.HeightPercent := 100.000000000000000000;
    lbemissao.WidthPercent := 100.000000000000000000;
    lbentrada.SetParentComponent(Self);
    lbentrada.Name := 'lbentrada';
    lbentrada.Left := 8;
    lbentrada.Top := 171;
    lbentrada.Width := 42;
    lbentrada.Height := 13;
    lbentrada.Caption := 'Entrada:';
    lbentrada.HeightPercent := 100.000000000000000000;
    lbentrada.WidthPercent := 100.000000000000000000;
    lbvalor_base_icms.SetParentComponent(Self);
    lbvalor_base_icms.Name := 'lbvalor_base_icms';
    lbvalor_base_icms.Left := 8;
    lbvalor_base_icms.Top := 198;
    lbvalor_base_icms.Width := 55;
    lbvalor_base_icms.Height := 13;
    lbvalor_base_icms.Caption := 'Base ICMS:';
    lbvalor_base_icms.HeightPercent := 100.000000000000000000;
    lbvalor_base_icms.WidthPercent := 100.000000000000000000;
    lbvalor_icms.SetParentComponent(Self);
    lbvalor_icms.Name := 'lbvalor_icms';
    lbvalor_icms.Left := 8;
    lbvalor_icms.Top := 225;
    lbvalor_icms.Width := 56;
    lbvalor_icms.Height := 13;
    lbvalor_icms.Caption := 'Valor ICMS:';
    lbvalor_icms.HeightPercent := 100.000000000000000000;
    lbvalor_icms.WidthPercent := 100.000000000000000000;
    lbvalor_icms_desonerado.SetParentComponent(Self);
    lbvalor_icms_desonerado.Name := 'lbvalor_icms_desonerado';
    lbvalor_icms_desonerado.Left := 8;
    lbvalor_icms_desonerado.Top := 251;
    lbvalor_icms_desonerado.Width := 93;
    lbvalor_icms_desonerado.Height := 13;
    lbvalor_icms_desonerado.Caption := 'Valor ICMS Deson.:';
    lbvalor_icms_desonerado.HeightPercent := 100.000000000000000000;
    lbvalor_icms_desonerado.WidthPercent := 100.000000000000000000;
    lbvalor_base_st.SetParentComponent(Self);
    lbvalor_base_st.Name := 'lbvalor_base_st';
    lbvalor_base_st.Left := 8;
    lbvalor_base_st.Top := 278;
    lbvalor_base_st.Width := 42;
    lbvalor_base_st.Height := 13;
    lbvalor_base_st.Caption := 'Base ST:';
    lbvalor_base_st.HeightPercent := 100.000000000000000000;
    lbvalor_base_st.WidthPercent := 100.000000000000000000;
    lbvalor_st.SetParentComponent(Self);
    lbvalor_st.Name := 'lbvalor_st';
    lbvalor_st.Left := 8;
    lbvalor_st.Top := 305;
    lbvalor_st.Width := 43;
    lbvalor_st.Height := 13;
    lbvalor_st.Caption := 'Valor ST:';
    lbvalor_st.HeightPercent := 100.000000000000000000;
    lbvalor_st.WidthPercent := 100.000000000000000000;
    lbvalor_ipi.SetParentComponent(Self);
    lbvalor_ipi.Name := 'lbvalor_ipi';
    lbvalor_ipi.Left := 8;
    lbvalor_ipi.Top := 332;
    lbvalor_ipi.Width := 45;
    lbvalor_ipi.Height := 13;
    lbvalor_ipi.Caption := 'Valor IPI:';
    lbvalor_ipi.HeightPercent := 100.000000000000000000;
    lbvalor_ipi.WidthPercent := 100.000000000000000000;
    lbvalor_pis.SetParentComponent(Self);
    lbvalor_pis.Name := 'lbvalor_pis';
    lbvalor_pis.Left := 8;
    lbvalor_pis.Top := 359;
    lbvalor_pis.Width := 47;
    lbvalor_pis.Height := 13;
    lbvalor_pis.Caption := 'Valor PIS:';
    lbvalor_pis.HeightPercent := 100.000000000000000000;
    lbvalor_pis.WidthPercent := 100.000000000000000000;
    lbvalor_cofins.SetParentComponent(Self);
    lbvalor_cofins.Name := 'lbvalor_cofins';
    lbvalor_cofins.Left := 8;
    lbvalor_cofins.Top := 386;
    lbvalor_cofins.Width := 69;
    lbvalor_cofins.Height := 13;
    lbvalor_cofins.Caption := 'Valor COFINS:';
    lbvalor_cofins.HeightPercent := 100.000000000000000000;
    lbvalor_cofins.WidthPercent := 100.000000000000000000;
    lbvalor_frete.SetParentComponent(Self);
    lbvalor_frete.Name := 'lbvalor_frete';
    lbvalor_frete.Left := 8;
    lbvalor_frete.Top := 413;
    lbvalor_frete.Width := 57;
    lbvalor_frete.Height := 13;
    lbvalor_frete.Caption := 'Valor Frete:';
    lbvalor_frete.HeightPercent := 100.000000000000000000;
    lbvalor_frete.WidthPercent := 100.000000000000000000;
    lbvalor_seguro.SetParentComponent(Self);
    lbvalor_seguro.Name := 'lbvalor_seguro';
    lbvalor_seguro.Left := 260;
    lbvalor_seguro.Top := 9;
    lbvalor_seguro.Width := 65;
    lbvalor_seguro.Height := 13;
    lbvalor_seguro.Caption := 'Valor Seguro:';
    lbvalor_seguro.HeightPercent := 100.000000000000000000;
    lbvalor_seguro.WidthPercent := 100.000000000000000000;
    lbvalor_outras.SetParentComponent(Self);
    lbvalor_outras.Name := 'lbvalor_outras';
    lbvalor_outras.Left := 260;
    lbvalor_outras.Top := 36;
    lbvalor_outras.Width := 64;
    lbvalor_outras.Height := 13;
    lbvalor_outras.Caption := 'Valor Outras:';
    lbvalor_outras.HeightPercent := 100.000000000000000000;
    lbvalor_outras.WidthPercent := 100.000000000000000000;
    lbacrescimo.SetParentComponent(Self);
    lbacrescimo.Name := 'lbacrescimo';
    lbacrescimo.Left := 260;
    lbacrescimo.Top := 63;
    lbacrescimo.Width := 74;
    lbacrescimo.Height := 13;
    lbacrescimo.Caption := 'Acr'#233'scimo (%):';
    lbacrescimo.HeightPercent := 100.000000000000000000;
    lbacrescimo.WidthPercent := 100.000000000000000000;
    lbvalor_acrescimo.SetParentComponent(Self);
    lbvalor_acrescimo.Name := 'lbvalor_acrescimo';
    lbvalor_acrescimo.Left := 260;
    lbvalor_acrescimo.Top := 90;
    lbvalor_acrescimo.Width := 79;
    lbvalor_acrescimo.Height := 13;
    lbvalor_acrescimo.Caption := 'Valor Acr'#233'scimo:';
    lbvalor_acrescimo.HeightPercent := 100.000000000000000000;
    lbvalor_acrescimo.WidthPercent := 100.000000000000000000;
    lbdesconto.SetParentComponent(Self);
    lbdesconto.Name := 'lbdesconto';
    lbdesconto.Left := 260;
    lbdesconto.Top := 117;
    lbdesconto.Width := 71;
    lbdesconto.Height := 13;
    lbdesconto.Caption := 'Desconto (%):';
    lbdesconto.HeightPercent := 100.000000000000000000;
    lbdesconto.WidthPercent := 100.000000000000000000;
    lbvalor_desconto.SetParentComponent(Self);
    lbvalor_desconto.Name := 'lbvalor_desconto';
    lbvalor_desconto.Left := 260;
    lbvalor_desconto.Top := 144;
    lbvalor_desconto.Width := 76;
    lbvalor_desconto.Height := 13;
    lbvalor_desconto.Caption := 'Valor Desconto:';
    lbvalor_desconto.HeightPercent := 100.000000000000000000;
    lbvalor_desconto.WidthPercent := 100.000000000000000000;
    lbvalor_itens.SetParentComponent(Self);
    lbvalor_itens.Name := 'lbvalor_itens';
    lbvalor_itens.Left := 260;
    lbvalor_itens.Top := 171;
    lbvalor_itens.Width := 56;
    lbvalor_itens.Height := 13;
    lbvalor_itens.Caption := 'Valor Itens:';
    lbvalor_itens.HeightPercent := 100.000000000000000000;
    lbvalor_itens.WidthPercent := 100.000000000000000000;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 260;
    lbvalor_total.Top := 198;
    lbvalor_total.Width := 28;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'Total:';
    lbvalor_total.HeightPercent := 100.000000000000000000;
    lbvalor_total.WidthPercent := 100.000000000000000000;
    lbobs.SetParentComponent(Self);
    lbobs.Name := 'lbobs';
    lbobs.Left := 260;
    lbobs.Top := 225;
    lbobs.Width := 67;
    lbobs.Height := 13;
    lbobs.Caption := 'Observa'#231#245'es:';
    lbobs.HeightPercent := 100.000000000000000000;
    lbobs.WidthPercent := 100.000000000000000000;
    lbchave_nfe.SetParentComponent(Self);
    lbchave_nfe.Name := 'lbchave_nfe';
    lbchave_nfe.Left := 260;
    lbchave_nfe.Top := 252;
    lbchave_nfe.Width := 57;
    lbchave_nfe.Height := 13;
    lbchave_nfe.Caption := 'Chave NFe:';
    lbchave_nfe.HeightPercent := 100.000000000000000000;
    lbchave_nfe.WidthPercent := 100.000000000000000000;
    lbicms_compoe_base_pis_confins.SetParentComponent(Self);
    lbicms_compoe_base_pis_confins.Name := 'lbicms_compoe_base_pis_confins';
    lbicms_compoe_base_pis_confins.Left := 517;
    lbicms_compoe_base_pis_confins.Top := 9;
    lbicms_compoe_base_pis_confins.Width := 150;
    lbicms_compoe_base_pis_confins.Height := 13;
    lbicms_compoe_base_pis_confins.Caption := 'ICMS Comp. Base PIS COFINS?';
    lbicms_compoe_base_pis_confins.HeightPercent := 100.000000000000000000;
    lbicms_compoe_base_pis_confins.WidthPercent := 100.000000000000000000;
    lbipi_compoe_base_pis_cofins.SetParentComponent(Self);
    lbipi_compoe_base_pis_cofins.Name := 'lbipi_compoe_base_pis_cofins';
    lbipi_compoe_base_pis_cofins.Left := 517;
    lbipi_compoe_base_pis_cofins.Top := 36;
    lbipi_compoe_base_pis_cofins.Width := 139;
    lbipi_compoe_base_pis_cofins.Height := 13;
    lbipi_compoe_base_pis_cofins.Caption := 'IPI Comp. Base PIS COFINS?';
    lbipi_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbipi_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbfrete_compoe_base_pis_cofins.SetParentComponent(Self);
    lbfrete_compoe_base_pis_cofins.Name := 'lbfrete_compoe_base_pis_cofins';
    lbfrete_compoe_base_pis_cofins.Left := 517;
    lbfrete_compoe_base_pis_cofins.Top := 63;
    lbfrete_compoe_base_pis_cofins.Width := 151;
    lbfrete_compoe_base_pis_cofins.Height := 13;
    lbfrete_compoe_base_pis_cofins.Caption := 'Frete Comp. Base PIS COFINS?';
    lbfrete_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbfrete_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbseguro_compoe_base_pis_cofins.SetParentComponent(Self);
    lbseguro_compoe_base_pis_cofins.Name := 'lbseguro_compoe_base_pis_cofins';
    lbseguro_compoe_base_pis_cofins.Left := 517;
    lbseguro_compoe_base_pis_cofins.Top := 90;
    lbseguro_compoe_base_pis_cofins.Width := 159;
    lbseguro_compoe_base_pis_cofins.Height := 13;
    lbseguro_compoe_base_pis_cofins.Caption := 'Seguro Comp. Base PIS COFINS?';
    lbseguro_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbseguro_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lboutras_compoe_base_pis_cofins.SetParentComponent(Self);
    lboutras_compoe_base_pis_cofins.Name := 'lboutras_compoe_base_pis_cofins';
    lboutras_compoe_base_pis_cofins.Left := 517;
    lboutras_compoe_base_pis_cofins.Top := 117;
    lboutras_compoe_base_pis_cofins.Width := 158;
    lboutras_compoe_base_pis_cofins.Height := 13;
    lboutras_compoe_base_pis_cofins.Caption := 'Outros Comp. Base PIS COFINS?';
    lboutras_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lboutras_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbplano_contas_id.SetParentComponent(Self);
    lbplano_contas_id.Name := 'lbplano_contas_id';
    lbplano_contas_id.Left := 260;
    lbplano_contas_id.Top := 278;
    lbplano_contas_id.Width := 67;
    lbplano_contas_id.Height := 13;
    lbplano_contas_id.Caption := 'Plano Contas:';
    lbplano_contas_id.HeightPercent := 100.000000000000000000;
    lbplano_contas_id.WidthPercent := 100.000000000000000000;
    lbplano_contas_contabil_id.SetParentComponent(Self);
    lbplano_contas_contabil_id.Name := 'lbplano_contas_contabil_id';
    lbplano_contas_contabil_id.Left := 260;
    lbplano_contas_contabil_id.Top := 305;
    lbplano_contas_contabil_id.Width := 97;
    lbplano_contas_contabil_id.Height := 13;
    lbplano_contas_contabil_id.Caption := 'Plano Contas Cont.:';
    lbplano_contas_contabil_id.HeightPercent := 100.000000000000000000;
    lbplano_contas_contabil_id.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 260;
    lbcodigo_interno.Top := 332;
    lbcodigo_interno.Width := 87;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Retaguarda:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 260;
    lbexcluido.Top := 359;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 260;
    lbinclusao.Top := 386;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 260;
    lbalteracao.Top := 413;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 517;
    lbexclusao.Top := 142;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbPaginationInfoItens.SetParentComponent(Self);
    lbPaginationInfoItens.Name := 'lbPaginationInfoItens';
    lbPaginationInfoItens.Left := 8;
    lbPaginationInfoItens.Top := 564;
    lbPaginationInfoItens.Width := 141;
    lbPaginationInfoItens.Height := 13;
    lbPaginationInfoItens.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoItens.HeightPercent := 100.000000000000000000;
    lbPaginationInfoItens.WidthPercent := 100.000000000000000000;
    lbPaginationInfoAPagar.SetParentComponent(Self);
    lbPaginationInfoAPagar.Name := 'lbPaginationInfoAPagar';
    lbPaginationInfoAPagar.Left := 254;
    lbPaginationInfoAPagar.Top := 658;
    lbPaginationInfoAPagar.Width := 141;
    lbPaginationInfoAPagar.Height := 13;
    lbPaginationInfoAPagar.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoAPagar.Color := clBtnFace;
    lbPaginationInfoAPagar.HeightPercent := 100.000000000000000000;
    lbPaginationInfoAPagar.WidthPercent := 100.000000000000000000;
    lbPaginationInfoPagamentos.SetParentComponent(Self);
    lbPaginationInfoPagamentos.Name := 'lbPaginationInfoPagamentos';
    lbPaginationInfoPagamentos.Left := 496;
    lbPaginationInfoPagamentos.Top := 658;
    lbPaginationInfoPagamentos.Width := 141;
    lbPaginationInfoPagamentos.Height := 13;
    lbPaginationInfoPagamentos.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoPagamentos.Color := clBtnFace;
    lbPaginationInfoPagamentos.HeightPercent := 100.000000000000000000;
    lbPaginationInfoPagamentos.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 714;
    btCancel.Top := 166;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 125;
    edid.Top := 5;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edfornecedores_id.SetParentComponent(Self);
    edfornecedores_id.Name := 'edfornecedores_id';
    edfornecedores_id.Left := 125;
    edfornecedores_id.Top := 33;
    edfornecedores_id.Width := 100;
    edfornecedores_id.Height := 21;
    edfornecedores_id.Enabled := False;
    edfornecedores_id.HeightPercent := 100.000000000000000000;
    edfornecedores_id.TabOrder := 9;
    edfornecedores_id.Text := 'edfornecedores_id';
    edfornecedores_id.WidthPercent := 100.000000000000000000;
    edfornecedores_id.DataField := 'fornecedor.razao_social_nome';
    edfornecedores_id.DataSource := DataSource;
    edcfop.SetParentComponent(Self);
    edcfop.Name := 'edcfop';
    edcfop.Left := 125;
    edcfop.Top := 60;
    edcfop.Width := 100;
    edcfop.Height := 21;
    edcfop.Enabled := False;
    edcfop.HeightPercent := 100.000000000000000000;
    edcfop.TabOrder := 10;
    edcfop.Text := 'edcfop';
    edcfop.WidthPercent := 100.000000000000000000;
    edcfop.DataField := 'cfop';
    edcfop.DataSource := DataSource;
    edmodelo.SetParentComponent(Self);
    edmodelo.Name := 'edmodelo';
    edmodelo.Left := 125;
    edmodelo.Top := 87;
    edmodelo.Width := 100;
    edmodelo.Height := 21;
    edmodelo.Enabled := False;
    edmodelo.HeightPercent := 100.000000000000000000;
    edmodelo.TabOrder := 11;
    edmodelo.Text := 'edmodelo';
    edmodelo.WidthPercent := 100.000000000000000000;
    edmodelo.DataField := 'modelo';
    edmodelo.DataSource := DataSource;
    edserie.SetParentComponent(Self);
    edserie.Name := 'edserie';
    edserie.Left := 125;
    edserie.Top := 114;
    edserie.Width := 100;
    edserie.Height := 21;
    edserie.Enabled := False;
    edserie.HeightPercent := 100.000000000000000000;
    edserie.TabOrder := 12;
    edserie.Text := 'edserie';
    edserie.WidthPercent := 100.000000000000000000;
    edserie.DataField := 'serie';
    edserie.DataSource := DataSource;
    edemissao.SetParentComponent(Self);
    edemissao.Name := 'edemissao';
    edemissao.Left := 125;
    edemissao.Top := 141;
    edemissao.Width := 100;
    edemissao.Height := 21;
    edemissao.Enabled := False;
    edemissao.HeightPercent := 100.000000000000000000;
    edemissao.TabOrder := 13;
    edemissao.Text := 'edemissao';
    edemissao.WidthPercent := 100.000000000000000000;
    edemissao.DataField := 'emissao';
    edemissao.DataSource := DataSource;
    edentrada.SetParentComponent(Self);
    edentrada.Name := 'edentrada';
    edentrada.Left := 125;
    edentrada.Top := 168;
    edentrada.Width := 100;
    edentrada.Height := 21;
    edentrada.Enabled := False;
    edentrada.HeightPercent := 100.000000000000000000;
    edentrada.TabOrder := 14;
    edentrada.Text := 'edentrada';
    edentrada.WidthPercent := 100.000000000000000000;
    edentrada.DataField := 'entrada';
    edentrada.DataSource := DataSource;
    edvalor_base_icms.SetParentComponent(Self);
    edvalor_base_icms.Name := 'edvalor_base_icms';
    edvalor_base_icms.Left := 125;
    edvalor_base_icms.Top := 195;
    edvalor_base_icms.Width := 100;
    edvalor_base_icms.Height := 21;
    edvalor_base_icms.Enabled := False;
    edvalor_base_icms.HeightPercent := 100.000000000000000000;
    edvalor_base_icms.TabOrder := 15;
    edvalor_base_icms.Text := 'edvalor_base_icms';
    edvalor_base_icms.WidthPercent := 100.000000000000000000;
    edvalor_base_icms.DataField := 'valor_base_icms';
    edvalor_base_icms.DataSource := DataSource;
    edvalor_icms.SetParentComponent(Self);
    edvalor_icms.Name := 'edvalor_icms';
    edvalor_icms.Left := 125;
    edvalor_icms.Top := 222;
    edvalor_icms.Width := 100;
    edvalor_icms.Height := 21;
    edvalor_icms.Enabled := False;
    edvalor_icms.HeightPercent := 100.000000000000000000;
    edvalor_icms.TabOrder := 16;
    edvalor_icms.Text := 'edvalor_icms';
    edvalor_icms.WidthPercent := 100.000000000000000000;
    edvalor_icms.DataField := 'valor_icms';
    edvalor_icms.DataSource := DataSource;
    edvalor_icms_desonerado.SetParentComponent(Self);
    edvalor_icms_desonerado.Name := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.Left := 125;
    edvalor_icms_desonerado.Top := 248;
    edvalor_icms_desonerado.Width := 100;
    edvalor_icms_desonerado.Height := 21;
    edvalor_icms_desonerado.Enabled := False;
    edvalor_icms_desonerado.HeightPercent := 100.000000000000000000;
    edvalor_icms_desonerado.TabOrder := 17;
    edvalor_icms_desonerado.Text := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.WidthPercent := 100.000000000000000000;
    edvalor_icms_desonerado.DataField := 'valor_icms_desonerado';
    edvalor_icms_desonerado.DataSource := DataSource;
    edvalor_base_st.SetParentComponent(Self);
    edvalor_base_st.Name := 'edvalor_base_st';
    edvalor_base_st.Left := 125;
    edvalor_base_st.Top := 275;
    edvalor_base_st.Width := 100;
    edvalor_base_st.Height := 21;
    edvalor_base_st.Enabled := False;
    edvalor_base_st.HeightPercent := 100.000000000000000000;
    edvalor_base_st.TabOrder := 18;
    edvalor_base_st.Text := 'edvalor_base_st';
    edvalor_base_st.WidthPercent := 100.000000000000000000;
    edvalor_base_st.DataField := 'valor_base_st';
    edvalor_base_st.DataSource := DataSource;
    edvalor_st.SetParentComponent(Self);
    edvalor_st.Name := 'edvalor_st';
    edvalor_st.Left := 125;
    edvalor_st.Top := 302;
    edvalor_st.Width := 100;
    edvalor_st.Height := 21;
    edvalor_st.Enabled := False;
    edvalor_st.HeightPercent := 100.000000000000000000;
    edvalor_st.TabOrder := 19;
    edvalor_st.Text := 'edvalor_st';
    edvalor_st.WidthPercent := 100.000000000000000000;
    edvalor_st.DataField := 'valor_st';
    edvalor_st.DataSource := DataSource;
    edvalor_ipi.SetParentComponent(Self);
    edvalor_ipi.Name := 'edvalor_ipi';
    edvalor_ipi.Left := 125;
    edvalor_ipi.Top := 329;
    edvalor_ipi.Width := 100;
    edvalor_ipi.Height := 21;
    edvalor_ipi.Enabled := False;
    edvalor_ipi.HeightPercent := 100.000000000000000000;
    edvalor_ipi.TabOrder := 20;
    edvalor_ipi.Text := 'edvalor_ipi';
    edvalor_ipi.WidthPercent := 100.000000000000000000;
    edvalor_ipi.DataField := 'valor_ipi';
    edvalor_ipi.DataSource := DataSource;
    edvalor_pis.SetParentComponent(Self);
    edvalor_pis.Name := 'edvalor_pis';
    edvalor_pis.Left := 125;
    edvalor_pis.Top := 356;
    edvalor_pis.Width := 100;
    edvalor_pis.Height := 21;
    edvalor_pis.Enabled := False;
    edvalor_pis.HeightPercent := 100.000000000000000000;
    edvalor_pis.TabOrder := 21;
    edvalor_pis.Text := 'edvalor_pis';
    edvalor_pis.WidthPercent := 100.000000000000000000;
    edvalor_pis.DataField := 'valor_pis';
    edvalor_pis.DataSource := DataSource;
    edvalor_cofins.SetParentComponent(Self);
    edvalor_cofins.Name := 'edvalor_cofins';
    edvalor_cofins.Left := 125;
    edvalor_cofins.Top := 383;
    edvalor_cofins.Width := 100;
    edvalor_cofins.Height := 21;
    edvalor_cofins.Enabled := False;
    edvalor_cofins.HeightPercent := 100.000000000000000000;
    edvalor_cofins.TabOrder := 22;
    edvalor_cofins.Text := 'edvalor_cofins';
    edvalor_cofins.WidthPercent := 100.000000000000000000;
    edvalor_cofins.DataField := 'valor_cofins';
    edvalor_cofins.DataSource := DataSource;
    edvalor_frete.SetParentComponent(Self);
    edvalor_frete.Name := 'edvalor_frete';
    edvalor_frete.Left := 125;
    edvalor_frete.Top := 410;
    edvalor_frete.Width := 100;
    edvalor_frete.Height := 21;
    edvalor_frete.Enabled := False;
    edvalor_frete.HeightPercent := 100.000000000000000000;
    edvalor_frete.TabOrder := 23;
    edvalor_frete.Text := 'edvalor_frete';
    edvalor_frete.WidthPercent := 100.000000000000000000;
    edvalor_frete.DataField := 'valor_frete';
    edvalor_frete.DataSource := DataSource;
    edvalor_seguro.SetParentComponent(Self);
    edvalor_seguro.Name := 'edvalor_seguro';
    edvalor_seguro.Left := 377;
    edvalor_seguro.Top := 6;
    edvalor_seguro.Width := 100;
    edvalor_seguro.Height := 21;
    edvalor_seguro.Enabled := False;
    edvalor_seguro.HeightPercent := 100.000000000000000000;
    edvalor_seguro.TabOrder := 24;
    edvalor_seguro.Text := 'edvalor_seguro';
    edvalor_seguro.WidthPercent := 100.000000000000000000;
    edvalor_seguro.DataField := 'valor_seguro';
    edvalor_seguro.DataSource := DataSource;
    edvalor_outras.SetParentComponent(Self);
    edvalor_outras.Name := 'edvalor_outras';
    edvalor_outras.Left := 377;
    edvalor_outras.Top := 33;
    edvalor_outras.Width := 100;
    edvalor_outras.Height := 21;
    edvalor_outras.Enabled := False;
    edvalor_outras.HeightPercent := 100.000000000000000000;
    edvalor_outras.TabOrder := 25;
    edvalor_outras.Text := 'edvalor_outras';
    edvalor_outras.WidthPercent := 100.000000000000000000;
    edvalor_outras.DataField := 'valor_outras';
    edvalor_outras.DataSource := DataSource;
    edacrescimo.SetParentComponent(Self);
    edacrescimo.Name := 'edacrescimo';
    edacrescimo.Left := 377;
    edacrescimo.Top := 60;
    edacrescimo.Width := 100;
    edacrescimo.Height := 21;
    edacrescimo.Enabled := False;
    edacrescimo.HeightPercent := 100.000000000000000000;
    edacrescimo.TabOrder := 26;
    edacrescimo.Text := 'edacrescimo';
    edacrescimo.WidthPercent := 100.000000000000000000;
    edacrescimo.DataField := 'acrescimo';
    edacrescimo.DataSource := DataSource;
    edvalor_acrescimo.SetParentComponent(Self);
    edvalor_acrescimo.Name := 'edvalor_acrescimo';
    edvalor_acrescimo.Left := 377;
    edvalor_acrescimo.Top := 87;
    edvalor_acrescimo.Width := 100;
    edvalor_acrescimo.Height := 21;
    edvalor_acrescimo.Enabled := False;
    edvalor_acrescimo.HeightPercent := 100.000000000000000000;
    edvalor_acrescimo.TabOrder := 27;
    edvalor_acrescimo.Text := 'edvalor_acrescimo';
    edvalor_acrescimo.WidthPercent := 100.000000000000000000;
    edvalor_acrescimo.DataField := 'valor_acrescimo';
    edvalor_acrescimo.DataSource := DataSource;
    eddesconto.SetParentComponent(Self);
    eddesconto.Name := 'eddesconto';
    eddesconto.Left := 377;
    eddesconto.Top := 114;
    eddesconto.Width := 100;
    eddesconto.Height := 21;
    eddesconto.Enabled := False;
    eddesconto.HeightPercent := 100.000000000000000000;
    eddesconto.TabOrder := 28;
    eddesconto.Text := 'eddesconto';
    eddesconto.WidthPercent := 100.000000000000000000;
    eddesconto.DataField := 'desconto';
    eddesconto.DataSource := DataSource;
    edvalor_desconto.SetParentComponent(Self);
    edvalor_desconto.Name := 'edvalor_desconto';
    edvalor_desconto.Left := 377;
    edvalor_desconto.Top := 141;
    edvalor_desconto.Width := 100;
    edvalor_desconto.Height := 21;
    edvalor_desconto.Enabled := False;
    edvalor_desconto.HeightPercent := 100.000000000000000000;
    edvalor_desconto.TabOrder := 29;
    edvalor_desconto.Text := 'edvalor_desconto';
    edvalor_desconto.WidthPercent := 100.000000000000000000;
    edvalor_desconto.DataField := 'valor_desconto';
    edvalor_desconto.DataSource := DataSource;
    edvalor_itens.SetParentComponent(Self);
    edvalor_itens.Name := 'edvalor_itens';
    edvalor_itens.Left := 377;
    edvalor_itens.Top := 168;
    edvalor_itens.Width := 100;
    edvalor_itens.Height := 21;
    edvalor_itens.Enabled := False;
    edvalor_itens.HeightPercent := 100.000000000000000000;
    edvalor_itens.TabOrder := 30;
    edvalor_itens.Text := 'edvalor_itens';
    edvalor_itens.WidthPercent := 100.000000000000000000;
    edvalor_itens.DataField := 'valor_itens';
    edvalor_itens.DataSource := DataSource;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 377;
    edvalor_total.Top := 195;
    edvalor_total.Width := 100;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := False;
    edvalor_total.HeightPercent := 100.000000000000000000;
    edvalor_total.TabOrder := 31;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.WidthPercent := 100.000000000000000000;
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    edobs.SetParentComponent(Self);
    edobs.Name := 'edobs';
    edobs.Left := 377;
    edobs.Top := 222;
    edobs.Width := 100;
    edobs.Height := 21;
    edobs.Enabled := False;
    edobs.HeightPercent := 100.000000000000000000;
    edobs.TabOrder := 32;
    edobs.Text := 'edobs';
    edobs.WidthPercent := 100.000000000000000000;
    edobs.DataField := 'obs';
    edobs.DataSource := DataSource;
    edchave_nfe.SetParentComponent(Self);
    edchave_nfe.Name := 'edchave_nfe';
    edchave_nfe.Left := 377;
    edchave_nfe.Top := 249;
    edchave_nfe.Width := 100;
    edchave_nfe.Height := 21;
    edchave_nfe.Enabled := False;
    edchave_nfe.HeightPercent := 100.000000000000000000;
    edchave_nfe.TabOrder := 33;
    edchave_nfe.Text := 'edchave_nfe';
    edchave_nfe.WidthPercent := 100.000000000000000000;
    edchave_nfe.DataField := 'chave_nfe';
    edchave_nfe.DataSource := DataSource;
    edplano_contas_id.SetParentComponent(Self);
    edplano_contas_id.Name := 'edplano_contas_id';
    edplano_contas_id.Left := 377;
    edplano_contas_id.Top := 275;
    edplano_contas_id.Width := 100;
    edplano_contas_id.Height := 21;
    edplano_contas_id.Enabled := False;
    edplano_contas_id.HeightPercent := 100.000000000000000000;
    edplano_contas_id.TabOrder := 39;
    edplano_contas_id.Text := 'edplano_contas_id';
    edplano_contas_id.WidthPercent := 100.000000000000000000;
    edplano_contas_id.DataField := 'plano_conta.nome';
    edplano_contas_id.DataSource := DataSource;
    edplano_contas_contabil_id.SetParentComponent(Self);
    edplano_contas_contabil_id.Name := 'edplano_contas_contabil_id';
    edplano_contas_contabil_id.Left := 377;
    edplano_contas_contabil_id.Top := 302;
    edplano_contas_contabil_id.Width := 100;
    edplano_contas_contabil_id.Height := 21;
    edplano_contas_contabil_id.Enabled := False;
    edplano_contas_contabil_id.HeightPercent := 100.000000000000000000;
    edplano_contas_contabil_id.TabOrder := 40;
    edplano_contas_contabil_id.Text := 'edplano_contas_contabil_id';
    edplano_contas_contabil_id.WidthPercent := 100.000000000000000000;
    edplano_contas_contabil_id.DataField := 'plano_conta_cont.nome';
    edplano_contas_contabil_id.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 377;
    edcodigo_interno.Top := 329;
    edcodigo_interno.Width := 100;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 41;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 377;
    edinclusao.Top := 383;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 43;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 377;
    edalteracao.Top := 410;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 44;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 714;
    edexclusao.Top := 139;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 45;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 377;
    cbxexcluido.Top := 356;
    cbxexcluido.Width := 100;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxicms_compoe_base_pis_confins.SetParentComponent(Self);
    cbxicms_compoe_base_pis_confins.Name := 'cbxicms_compoe_base_pis_confins';
    cbxicms_compoe_base_pis_confins.Left := 710;
    cbxicms_compoe_base_pis_confins.Top := 5;
    cbxicms_compoe_base_pis_confins.Width := 100;
    cbxicms_compoe_base_pis_confins.Height := 22;
    cbxicms_compoe_base_pis_confins.Caption := 'cbxicms_compoe_base_pis_confins';
    cbxicms_compoe_base_pis_confins.ChildOrder := 33;
    cbxicms_compoe_base_pis_confins.Enabled := False;
    cbxicms_compoe_base_pis_confins.HeightPercent := 100.000000000000000000;
    cbxicms_compoe_base_pis_confins.WidthPercent := 100.000000000000000000;
    cbxicms_compoe_base_pis_confins.DataField := 'icms_compoe_base_pis_confins';
    cbxicms_compoe_base_pis_confins.DataSource := DataSource;
    cbxipi_compoe_base_pis_cofins.SetParentComponent(Self);
    cbxipi_compoe_base_pis_cofins.Name := 'cbxipi_compoe_base_pis_cofins';
    cbxipi_compoe_base_pis_cofins.Left := 710;
    cbxipi_compoe_base_pis_cofins.Top := 33;
    cbxipi_compoe_base_pis_cofins.Width := 100;
    cbxipi_compoe_base_pis_cofins.Height := 22;
    cbxipi_compoe_base_pis_cofins.Caption := 'cbxipi_compoe_base_pis_cofins';
    cbxipi_compoe_base_pis_cofins.ChildOrder := 33;
    cbxipi_compoe_base_pis_cofins.Enabled := False;
    cbxipi_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxipi_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxipi_compoe_base_pis_cofins.DataField := 'ipi_compoe_base_pis_cofins';
    cbxipi_compoe_base_pis_cofins.DataSource := DataSource;
    cbxfrete_compoe_base_pis_cofins.SetParentComponent(Self);
    cbxfrete_compoe_base_pis_cofins.Name := 'cbxfrete_compoe_base_pis_cofins';
    cbxfrete_compoe_base_pis_cofins.Left := 710;
    cbxfrete_compoe_base_pis_cofins.Top := 60;
    cbxfrete_compoe_base_pis_cofins.Width := 100;
    cbxfrete_compoe_base_pis_cofins.Height := 22;
    cbxfrete_compoe_base_pis_cofins.Caption := 'cbxfrete_compoe_base_pis_cofins';
    cbxfrete_compoe_base_pis_cofins.ChildOrder := 33;
    cbxfrete_compoe_base_pis_cofins.Enabled := False;
    cbxfrete_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxfrete_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxfrete_compoe_base_pis_cofins.DataField := 'frete_compoe_base_pis_cofins';
    cbxfrete_compoe_base_pis_cofins.DataSource := DataSource;
    cbxseguro_compoe_base_pis_cofins.SetParentComponent(Self);
    cbxseguro_compoe_base_pis_cofins.Name := 'cbxseguro_compoe_base_pis_cofins';
    cbxseguro_compoe_base_pis_cofins.Left := 714;
    cbxseguro_compoe_base_pis_cofins.Top := 87;
    cbxseguro_compoe_base_pis_cofins.Width := 100;
    cbxseguro_compoe_base_pis_cofins.Height := 22;
    cbxseguro_compoe_base_pis_cofins.Caption := 'cbxseguro_compoe_base_pis_cofins';
    cbxseguro_compoe_base_pis_cofins.ChildOrder := 33;
    cbxseguro_compoe_base_pis_cofins.Enabled := False;
    cbxseguro_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxseguro_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxseguro_compoe_base_pis_cofins.DataField := 'seguro_compoe_base_pis_cofins';
    cbxseguro_compoe_base_pis_cofins.DataSource := DataSource;
    cbxoutras_compoe_base_pis_cofins.SetParentComponent(Self);
    cbxoutras_compoe_base_pis_cofins.Name := 'cbxoutras_compoe_base_pis_cofins';
    cbxoutras_compoe_base_pis_cofins.Left := 714;
    cbxoutras_compoe_base_pis_cofins.Top := 114;
    cbxoutras_compoe_base_pis_cofins.Width := 100;
    cbxoutras_compoe_base_pis_cofins.Height := 22;
    cbxoutras_compoe_base_pis_cofins.Caption := 'cbxoutras_compoe_base_pis_cofins';
    cbxoutras_compoe_base_pis_cofins.ChildOrder := 33;
    cbxoutras_compoe_base_pis_cofins.Enabled := False;
    cbxoutras_compoe_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxoutras_compoe_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxoutras_compoe_base_pis_cofins.DataField := 'outras_compoe_base_pis_cofins';
    cbxoutras_compoe_base_pis_cofins.DataSource := DataSource;
    btnCopiarChaveAcesso.SetParentComponent(Self);
    btnCopiarChaveAcesso.Name := 'btnCopiarChaveAcesso';
    btnCopiarChaveAcesso.Left := 477;
    btnCopiarChaveAcesso.Top := 249;
    btnCopiarChaveAcesso.Width := 30;
    btnCopiarChaveAcesso.Height := 21;
    btnCopiarChaveAcesso.ChildOrder := 22;
    btnCopiarChaveAcesso.HeightPercent := 100.000000000000000000;
    btnCopiarChaveAcesso.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChaveAcesso, Self, 'OnClick', 'btnCopiarChaveAcessoClick');
    tblItens.SetParentComponent(Self);
    tblItens.Name := 'tblItens';
    tblItens.Left := 8;
    tblItens.Top := 499;
    tblItens.Width := 225;
    tblItens.Height := 102;
    tblItens.ElementClassName := 'table-responsive';
    tblItens.BorderColor := clSilver;
    tblItens.ChildOrder := 28;
    tblItens.ColHeader := False;
    tblItens.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblItens, Self, 'OnGetCellClass', 'tblItensGetCellClass');
    tblItens.Columns.Clear;
    with tblItens.Columns.Add do
    begin
      DataField := 'item';
      Title := 'item';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'prod.codigo_interno';
      Title := 'C'#243'd. Produto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'produto_nome';
      Title := 'Produto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'unidade.sigla';
      Title := 'Unidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'valor_unitario';
      Title := 'Pre'#231'o';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Total';
    end;
    tblItens.DataSource := dtsItens;
    cbPageSizeItens.SetParentComponent(Self);
    cbPageSizeItens.Name := 'cbPageSizeItens';
    cbPageSizeItens.Left := 8;
    cbPageSizeItens.Top := 461;
    cbPageSizeItens.Width := 81;
    cbPageSizeItens.Height := 21;
    cbPageSizeItens.HeightPercent := 100.000000000000000000;
    cbPageSizeItens.TabOrder := 2;
    cbPageSizeItens.Text := '10';
    cbPageSizeItens.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeItens, Self, 'OnChange', 'cbPageSizeItensChange');
    cbPageSizeItens.ItemIndex := 0;
    cbPageSizeItens.Items.BeginUpdate;
    try
      cbPageSizeItens.Items.Clear;
      cbPageSizeItens.Items.Add('10');
      cbPageSizeItens.Items.Add('25');
      cbPageSizeItens.Items.Add('50');
      cbPageSizeItens.Items.Add('100');
    finally
      cbPageSizeItens.Items.EndUpdate;
    end;
    edSearchItens.SetParentComponent(Self);
    edSearchItens.Name := 'edSearchItens';
    edSearchItens.Left := 95;
    edSearchItens.Top := 461;
    edSearchItens.Width := 54;
    edSearchItens.Height := 21;
    edSearchItens.ChildOrder := 30;
    edSearchItens.HeightPercent := 100.000000000000000000;
    edSearchItens.TabOrder := 3;
    edSearchItens.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchItens, Self, 'OnKeyDown', 'edSearchItensKeyDown');
    SetEvent(edSearchItens, Self, 'OnKeyUp', 'edSearchItensKeyUp');
    pnlItensPromocao.SetParentComponent(Self);
    pnlItensPromocao.Name := 'pnlItensPromocao';
    pnlItensPromocao.Left := 8;
    pnlItensPromocao.Top := 439;
    pnlItensPromocao.Width := 225;
    pnlItensPromocao.Height := 17;
    pnlItensPromocao.Caption := 'Espa'#231'o tabela Itens';
    pnlItensPromocao.ChildOrder := 23;
    pnlItensPromocao.Color := clInfoText;
    pnlItensPromocao.Font.Charset := DEFAULT_CHARSET;
    pnlItensPromocao.Font.Color := clWhite;
    pnlItensPromocao.Font.Height := -11;
    pnlItensPromocao.Font.Name := 'Tahoma';
    pnlItensPromocao.Font.Style := [fsBold];
    pnlItensPromocao.ParentFont := False;
    pnlItensPromocao.TabOrder := 43;
    pnlItensPromocao.Visible := False;
    btnItensTab.SetParentComponent(Self);
    btnItensTab.Name := 'btnItensTab';
    btnItensTab.Left := 155;
    btnItensTab.Top := 460;
    btnItensTab.Width := 78;
    btnItensTab.Height := 25;
    btnItensTab.Caption := 'Itens';
    btnItensTab.ChildOrder := 34;
    btnItensTab.HeightPercent := 100.000000000000000000;
    btnItensTab.TabOrder := 1;
    btnItensTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnItensTab, Self, 'OnClick', 'btnItensTabClick');
    lcPaginatorItens.SetParentComponent(Self);
    lcPaginatorItens.Name := 'lcPaginatorItens';
    lcPaginatorItens.Left := 112;
    lcPaginatorItens.Top := 564;
    lcPaginatorItens.Width := 121;
    lcPaginatorItens.Height := 13;
    lcPaginatorItens.HeightPercent := 100.000000000000000000;
    lcPaginatorItens.WidthPercent := 100.000000000000000000;
    lcPaginatorItens.ChildOrder := 132;
    lcPaginatorItens.DefaultItemClassName := 'page-item';
    lcPaginatorItens.DefaultItemLinkClassName := 'page-link';
    lcPaginatorItens.ElementListClassName := 'pagination';
    lcPaginatorItens.Items.Clear;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorItens.Style := lsPagination;
    pnlTabelaAReceber.SetParentComponent(Self);
    pnlTabelaAReceber.Name := 'pnlTabelaAReceber';
    pnlTabelaAReceber.Left := 251;
    pnlTabelaAReceber.Top := 439;
    pnlTabelaAReceber.Width := 225;
    pnlTabelaAReceber.Height := 17;
    pnlTabelaAReceber.Caption := 'Espa'#231'o APagar';
    pnlTabelaAReceber.ChildOrder := 23;
    pnlTabelaAReceber.Color := clInfoText;
    pnlTabelaAReceber.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaAReceber.Font.Color := clWhite;
    pnlTabelaAReceber.Font.Height := -11;
    pnlTabelaAReceber.Font.Name := 'Tahoma';
    pnlTabelaAReceber.Font.Style := [fsBold];
    pnlTabelaAReceber.ParentFont := False;
    pnlTabelaAReceber.TabOrder := 46;
    pnlTabelaAReceber.Visible := False;
    tblAPagar.SetParentComponent(Self);
    tblAPagar.Name := 'tblAPagar';
    tblAPagar.Left := 251;
    tblAPagar.Top := 493;
    tblAPagar.Width := 225;
    tblAPagar.Height := 102;
    tblAPagar.ElementClassName := 'table-responsive';
    tblAPagar.BorderColor := clSilver;
    tblAPagar.ChildOrder := 82;
    tblAPagar.ColHeader := False;
    tblAPagar.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAPagar, Self, 'OnGetCellData', 'tblAPagarGetCellData');
    SetEvent(tblAPagar, Self, 'OnGetCellClass', 'tblAPagarGetCellClass');
    tblAPagar.Columns.Clear;
    with tblAPagar.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'Doc./Parcela';
    end;
    with tblAPagar.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'Emiss'#227'o';
    end;
    with tblAPagar.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'Vencimento';
    end;
    with tblAPagar.Columns.Add do
    begin
      DataField := 'saldo';
      Title := 'Saldo Pendente';
    end;
    with tblAPagar.Columns.Add do
    begin
      DataField := 'pago';
      Title := 'Valor Pago';
    end;
    with tblAPagar.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'Valor Total';
    end;
    tblAPagar.DataSource := dtsAPagar;
    lcPaginatorAPagar.SetParentComponent(Self);
    lcPaginatorAPagar.Name := 'lcPaginatorAPagar';
    lcPaginatorAPagar.Left := 374;
    lcPaginatorAPagar.Top := 656;
    lcPaginatorAPagar.Width := 102;
    lcPaginatorAPagar.Height := 15;
    lcPaginatorAPagar.HeightPercent := 100.000000000000000000;
    lcPaginatorAPagar.WidthPercent := 100.000000000000000000;
    lcPaginatorAPagar.ChildOrder := 81;
    lcPaginatorAPagar.DefaultItemClassName := 'page-item';
    lcPaginatorAPagar.DefaultItemLinkClassName := 'page-link';
    lcPaginatorAPagar.ElementListClassName := 'pagination';
    lcPaginatorAPagar.Items.Clear;
    with lcPaginatorAPagar.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorAPagar.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorAPagar.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorAPagar.Style := lsPagination;
    tblPagamentos.SetParentComponent(Self);
    tblPagamentos.Name := 'tblPagamentos';
    tblPagamentos.Left := 493;
    tblPagamentos.Top := 490;
    tblPagamentos.Width := 225;
    tblPagamentos.Height := 97;
    tblPagamentos.ElementClassName := 'table-responsive';
    tblPagamentos.BorderColor := clSilver;
    tblPagamentos.ChildOrder := 82;
    tblPagamentos.ColHeader := False;
    tblPagamentos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblPagamentos, Self, 'OnGetCellClass', 'tblPagamentosGetCellClass');
    tblPagamentos.Columns.Clear;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'apagar.documento';
      Title := 'Doc./Parcela';
    end;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'modalidade.nome';
      Title := 'Modalidade';
    end;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'data';
      Title := 'Data Pagamento';
    end;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'Valor';
    end;
    tblPagamentos.DataSource := dtsPagamentos;
    pnlTabelaPagamentos.SetParentComponent(Self);
    pnlTabelaPagamentos.Name := 'pnlTabelaPagamentos';
    pnlTabelaPagamentos.Left := 493;
    pnlTabelaPagamentos.Top := 439;
    pnlTabelaPagamentos.Width := 225;
    pnlTabelaPagamentos.Height := 17;
    pnlTabelaPagamentos.Caption := 'Espa'#231'o Pagamentos';
    pnlTabelaPagamentos.ChildOrder := 23;
    pnlTabelaPagamentos.Color := clInfoText;
    pnlTabelaPagamentos.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaPagamentos.Font.Color := clWhite;
    pnlTabelaPagamentos.Font.Height := -11;
    pnlTabelaPagamentos.Font.Name := 'Tahoma';
    pnlTabelaPagamentos.Font.Style := [fsBold];
    pnlTabelaPagamentos.ParentFont := False;
    pnlTabelaPagamentos.TabOrder := 50;
    pnlTabelaPagamentos.Visible := False;
    btnFinanceiroTab.SetParentComponent(Self);
    btnFinanceiroTab.Name := 'btnFinanceiroTab';
    btnFinanceiroTab.Left := 249;
    btnFinanceiroTab.Top := 462;
    btnFinanceiroTab.Width := 78;
    btnFinanceiroTab.Height := 25;
    btnFinanceiroTab.Caption := 'Financeiro';
    btnFinanceiroTab.ChildOrder := 34;
    btnFinanceiroTab.HeightPercent := 100.000000000000000000;
    btnFinanceiroTab.TabOrder := 1;
    btnFinanceiroTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFinanceiroTab, Self, 'OnClick', 'btnFinanceiroTabClick');
    btnPagamentosTab.SetParentComponent(Self);
    btnPagamentosTab.Name := 'btnPagamentosTab';
    btnPagamentosTab.Left := 493;
    btnPagamentosTab.Top := 462;
    btnPagamentosTab.Width := 78;
    btnPagamentosTab.Height := 25;
    btnPagamentosTab.Caption := 'Pagamentos';
    btnPagamentosTab.ChildOrder := 34;
    btnPagamentosTab.HeightPercent := 100.000000000000000000;
    btnPagamentosTab.TabOrder := 1;
    btnPagamentosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnPagamentosTab, Self, 'OnClick', 'btnPagamentosTabClick');
    lcPaginatorPagamentos.SetParentComponent(Self);
    lcPaginatorPagamentos.Name := 'lcPaginatorPagamentos';
    lcPaginatorPagamentos.Left := 616;
    lcPaginatorPagamentos.Top := 653;
    lcPaginatorPagamentos.Width := 102;
    lcPaginatorPagamentos.Height := 15;
    lcPaginatorPagamentos.HeightPercent := 100.000000000000000000;
    lcPaginatorPagamentos.WidthPercent := 100.000000000000000000;
    lcPaginatorPagamentos.ChildOrder := 81;
    lcPaginatorPagamentos.DefaultItemClassName := 'page-item';
    lcPaginatorPagamentos.DefaultItemLinkClassName := 'page-link';
    lcPaginatorPagamentos.ElementListClassName := 'pagination';
    lcPaginatorPagamentos.Items.Clear;
    with lcPaginatorPagamentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorPagamentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorPagamentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorPagamentos.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ComprasDataset;
    DataSource.Left := 528;
    DataSource.Top := 168;
    ComprasDataset.SetParentComponent(Self);
    ComprasDataset.Name := 'ComprasDataset';
    ComprasDataset.AfterApplyUpdates := ComprasDatasetAfterApplyUpdates;
    ComprasDataset.AfterOpen := ComprasDatasetAfterOpen;
    ComprasDataset.EntitySetName := 'Compras';
    ComprasDataset.Connection := DMConnection.ApiConnection;
    ComprasDataset.Left := 600;
    ComprasDataset.Top := 168;
    ComprasDatasetid.SetParentComponent(ComprasDataset);
    ComprasDatasetid.Name := 'ComprasDatasetid';
    ComprasDatasetid.FieldName := 'id';
    ComprasDatasetid.Required := True;
    ComprasDatasetfornecedores_id.SetParentComponent(ComprasDataset);
    ComprasDatasetfornecedores_id.Name := 'ComprasDatasetfornecedores_id';
    ComprasDatasetfornecedores_id.FieldName := 'fornecedores_id';
    ComprasDatasetfornecedores_id.Required := True;
    ComprasDatasetcfop.SetParentComponent(ComprasDataset);
    ComprasDatasetcfop.Name := 'ComprasDatasetcfop';
    ComprasDatasetcfop.FieldName := 'cfop';
    ComprasDatasetcfop.Required := True;
    SetEvent(ComprasDatasetcfop, Self, 'OnGetText', 'ComprasDatasetcfopGetText');
    ComprasDatasetcfop.Size := 255;
    ComprasDatasetmodelo.SetParentComponent(ComprasDataset);
    ComprasDatasetmodelo.Name := 'ComprasDatasetmodelo';
    ComprasDatasetmodelo.FieldName := 'modelo';
    ComprasDatasetmodelo.Size := 255;
    ComprasDatasetserie.SetParentComponent(ComprasDataset);
    ComprasDatasetserie.Name := 'ComprasDatasetserie';
    ComprasDatasetserie.FieldName := 'serie';
    ComprasDatasetserie.Size := 255;
    ComprasDatasetemissao.SetParentComponent(ComprasDataset);
    ComprasDatasetemissao.Name := 'ComprasDatasetemissao';
    ComprasDatasetemissao.FieldName := 'emissao';
    ComprasDatasetemissao.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetentrada.SetParentComponent(ComprasDataset);
    ComprasDatasetentrada.Name := 'ComprasDatasetentrada';
    ComprasDatasetentrada.FieldName := 'entrada';
    ComprasDatasetentrada.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetvalor_base_icms.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_base_icms.Name := 'ComprasDatasetvalor_base_icms';
    ComprasDatasetvalor_base_icms.FieldName := 'valor_base_icms';
    ComprasDatasetvalor_base_icms.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_icms.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_icms.Name := 'ComprasDatasetvalor_icms';
    ComprasDatasetvalor_icms.FieldName := 'valor_icms';
    ComprasDatasetvalor_icms.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_icms_desonerado.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_icms_desonerado.Name := 'ComprasDatasetvalor_icms_desonerado';
    ComprasDatasetvalor_icms_desonerado.FieldName := 'valor_icms_desonerado';
    ComprasDatasetvalor_icms_desonerado.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_base_st.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_base_st.Name := 'ComprasDatasetvalor_base_st';
    ComprasDatasetvalor_base_st.FieldName := 'valor_base_st';
    ComprasDatasetvalor_base_st.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_st.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_st.Name := 'ComprasDatasetvalor_st';
    ComprasDatasetvalor_st.FieldName := 'valor_st';
    ComprasDatasetvalor_st.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_ipi.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_ipi.Name := 'ComprasDatasetvalor_ipi';
    ComprasDatasetvalor_ipi.FieldName := 'valor_ipi';
    ComprasDatasetvalor_ipi.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_pis.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_pis.Name := 'ComprasDatasetvalor_pis';
    ComprasDatasetvalor_pis.FieldName := 'valor_pis';
    ComprasDatasetvalor_pis.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_cofins.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_cofins.Name := 'ComprasDatasetvalor_cofins';
    ComprasDatasetvalor_cofins.FieldName := 'valor_cofins';
    ComprasDatasetvalor_cofins.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_frete.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_frete.Name := 'ComprasDatasetvalor_frete';
    ComprasDatasetvalor_frete.FieldName := 'valor_frete';
    ComprasDatasetvalor_frete.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_seguro.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_seguro.Name := 'ComprasDatasetvalor_seguro';
    ComprasDatasetvalor_seguro.FieldName := 'valor_seguro';
    ComprasDatasetvalor_seguro.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_outras.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_outras.Name := 'ComprasDatasetvalor_outras';
    ComprasDatasetvalor_outras.FieldName := 'valor_outras';
    ComprasDatasetvalor_outras.DisplayFormat := '#,##0.00';
    ComprasDatasetacrescimo.SetParentComponent(ComprasDataset);
    ComprasDatasetacrescimo.Name := 'ComprasDatasetacrescimo';
    ComprasDatasetacrescimo.FieldName := 'acrescimo';
    ComprasDatasetacrescimo.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_acrescimo.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_acrescimo.Name := 'ComprasDatasetvalor_acrescimo';
    ComprasDatasetvalor_acrescimo.FieldName := 'valor_acrescimo';
    ComprasDatasetvalor_acrescimo.DisplayFormat := '#,##0.00';
    ComprasDatasetdesconto.SetParentComponent(ComprasDataset);
    ComprasDatasetdesconto.Name := 'ComprasDatasetdesconto';
    ComprasDatasetdesconto.FieldName := 'desconto';
    ComprasDatasetdesconto.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_desconto.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_desconto.Name := 'ComprasDatasetvalor_desconto';
    ComprasDatasetvalor_desconto.FieldName := 'valor_desconto';
    ComprasDatasetvalor_desconto.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_itens.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_itens.Name := 'ComprasDatasetvalor_itens';
    ComprasDatasetvalor_itens.FieldName := 'valor_itens';
    ComprasDatasetvalor_itens.Required := True;
    ComprasDatasetvalor_itens.DisplayFormat := '#,##0.00';
    ComprasDatasetvalor_total.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_total.Name := 'ComprasDatasetvalor_total';
    ComprasDatasetvalor_total.FieldName := 'valor_total';
    ComprasDatasetvalor_total.Required := True;
    ComprasDatasetvalor_total.DisplayFormat := '#,##0.00';
    ComprasDatasetobs.SetParentComponent(ComprasDataset);
    ComprasDatasetobs.Name := 'ComprasDatasetobs';
    ComprasDatasetobs.FieldName := 'obs';
    ComprasDatasetobs.Size := 255;
    ComprasDatasetchave_nfe.SetParentComponent(ComprasDataset);
    ComprasDatasetchave_nfe.Name := 'ComprasDatasetchave_nfe';
    ComprasDatasetchave_nfe.FieldName := 'chave_nfe';
    ComprasDatasetchave_nfe.Size := 255;
    ComprasDataseticms_compoe_base_pis_confins.SetParentComponent(ComprasDataset);
    ComprasDataseticms_compoe_base_pis_confins.Name := 'ComprasDataseticms_compoe_base_pis_confins';
    ComprasDataseticms_compoe_base_pis_confins.FieldName := 'icms_compoe_base_pis_confins';
    ComprasDataseticms_compoe_base_pis_confins.Required := True;
    ComprasDatasetipi_compoe_base_pis_cofins.SetParentComponent(ComprasDataset);
    ComprasDatasetipi_compoe_base_pis_cofins.Name := 'ComprasDatasetipi_compoe_base_pis_cofins';
    ComprasDatasetipi_compoe_base_pis_cofins.FieldName := 'ipi_compoe_base_pis_cofins';
    ComprasDatasetipi_compoe_base_pis_cofins.Required := True;
    ComprasDatasetfrete_compoe_base_pis_cofins.SetParentComponent(ComprasDataset);
    ComprasDatasetfrete_compoe_base_pis_cofins.Name := 'ComprasDatasetfrete_compoe_base_pis_cofins';
    ComprasDatasetfrete_compoe_base_pis_cofins.FieldName := 'frete_compoe_base_pis_cofins';
    ComprasDatasetfrete_compoe_base_pis_cofins.Required := True;
    ComprasDatasetseguro_compoe_base_pis_cofins.SetParentComponent(ComprasDataset);
    ComprasDatasetseguro_compoe_base_pis_cofins.Name := 'ComprasDatasetseguro_compoe_base_pis_cofins';
    ComprasDatasetseguro_compoe_base_pis_cofins.FieldName := 'seguro_compoe_base_pis_cofins';
    ComprasDatasetseguro_compoe_base_pis_cofins.Required := True;
    ComprasDatasetoutras_compoe_base_pis_cofins.SetParentComponent(ComprasDataset);
    ComprasDatasetoutras_compoe_base_pis_cofins.Name := 'ComprasDatasetoutras_compoe_base_pis_cofins';
    ComprasDatasetoutras_compoe_base_pis_cofins.FieldName := 'outras_compoe_base_pis_cofins';
    ComprasDatasetoutras_compoe_base_pis_cofins.Required := True;
    ComprasDatasetplano_contas_id.SetParentComponent(ComprasDataset);
    ComprasDatasetplano_contas_id.Name := 'ComprasDatasetplano_contas_id';
    ComprasDatasetplano_contas_id.FieldName := 'plano_contas_id';
    ComprasDatasetplano_contas_id.Required := True;
    ComprasDatasetplano_contas_contabil_id.SetParentComponent(ComprasDataset);
    ComprasDatasetplano_contas_contabil_id.Name := 'ComprasDatasetplano_contas_contabil_id';
    ComprasDatasetplano_contas_contabil_id.FieldName := 'plano_contas_contabil_id';
    ComprasDatasetcodigo_interno.SetParentComponent(ComprasDataset);
    ComprasDatasetcodigo_interno.Name := 'ComprasDatasetcodigo_interno';
    ComprasDatasetcodigo_interno.FieldName := 'codigo_interno';
    ComprasDatasetcodigo_interno.Required := True;
    ComprasDatasetexcluido.SetParentComponent(ComprasDataset);
    ComprasDatasetexcluido.Name := 'ComprasDatasetexcluido';
    ComprasDatasetexcluido.FieldName := 'excluido';
    ComprasDatasetinclusao.SetParentComponent(ComprasDataset);
    ComprasDatasetinclusao.Name := 'ComprasDatasetinclusao';
    ComprasDatasetinclusao.FieldName := 'inclusao';
    ComprasDatasetinclusao.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetalteracao.SetParentComponent(ComprasDataset);
    ComprasDatasetalteracao.Name := 'ComprasDatasetalteracao';
    ComprasDatasetalteracao.FieldName := 'alteracao';
    ComprasDatasetalteracao.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetexclusao.SetParentComponent(ComprasDataset);
    ComprasDatasetexclusao.Name := 'ComprasDatasetexclusao';
    ComprasDatasetexclusao.FieldName := 'exclusao';
    ComprasDatasetexclusao.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetcfop_cfopnome.SetParentComponent(ComprasDataset);
    ComprasDatasetcfop_cfopnome.Name := 'ComprasDatasetcfop_cfopnome';
    ComprasDatasetcfop_cfopnome.FieldName := 'cfop_cfop.nome';
    ComprasDatasetplano_contanome.SetParentComponent(ComprasDataset);
    ComprasDatasetplano_contanome.Name := 'ComprasDatasetplano_contanome';
    ComprasDatasetplano_contanome.FieldName := 'plano_conta.nome';
    ComprasDatasetplano_conta_contnome.SetParentComponent(ComprasDataset);
    ComprasDatasetplano_conta_contnome.Name := 'ComprasDatasetplano_conta_contnome';
    ComprasDatasetplano_conta_contnome.FieldName := 'plano_conta_cont.nome';
    ComprasDatasetfornecedorrazao_social_nome.SetParentComponent(ComprasDataset);
    ComprasDatasetfornecedorrazao_social_nome.Name := 'ComprasDatasetfornecedorrazao_social_nome';
    ComprasDatasetfornecedorrazao_social_nome.FieldName := 'fornecedor.razao_social_nome';
    XDataClientComprasGet.SetParentComponent(Self);
    XDataClientComprasGet.Name := 'XDataClientComprasGet';
    XDataClientComprasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientComprasGet, Self, 'OnLoad', 'XDataClientComprasGetLoad');
    XDataClientComprasGet.Left := 680;
    XDataClientComprasGet.Top := 184;
    cdsItens.SetParentComponent(Self);
    cdsItens.Name := 'cdsItens';
    cdsItens.EntitySetName := 'Itens_Entrada';
    cdsItens.Connection := DMConnection.ApiConnection;
    cdsItens.Left := 88;
    cdsItens.Top := 549;
    cdsItensitem.SetParentComponent(cdsItens);
    cdsItensitem.Name := 'cdsItensitem';
    cdsItensitem.FieldName := 'item';
    SetEvent(cdsItensitem, Self, 'OnGetText', 'cdsItensitemGetText');
    cdsItensproduto_nome.SetParentComponent(cdsItens);
    cdsItensproduto_nome.Name := 'cdsItensproduto_nome';
    cdsItensproduto_nome.FieldName := 'produto_nome';
    SetEvent(cdsItensproduto_nome, Self, 'OnGetText', 'cdsItensproduto_nomeGetText');
    cdsItensproduto_nome.Size := 255;
    cdsItensquantidade.SetParentComponent(cdsItens);
    cdsItensquantidade.Name := 'cdsItensquantidade';
    cdsItensquantidade.FieldName := 'quantidade';
    cdsItensquantidade.Required := True;
    cdsItensquantidade.DisplayFormat := '#,##0.000';
    cdsItensvalor_unitario.SetParentComponent(cdsItens);
    cdsItensvalor_unitario.Name := 'cdsItensvalor_unitario';
    cdsItensvalor_unitario.FieldName := 'valor_unitario';
    cdsItensvalor_unitario.Required := True;
    cdsItensvalor_unitario.DisplayFormat := '#,##0.00';
    cdsItensvalor_total.SetParentComponent(cdsItens);
    cdsItensvalor_total.Name := 'cdsItensvalor_total';
    cdsItensvalor_total.FieldName := 'valor_total';
    cdsItensvalor_total.Required := True;
    cdsItensvalor_total.DisplayFormat := '#,##0.00';
    cdsItensprodcodigo_interno.SetParentComponent(cdsItens);
    cdsItensprodcodigo_interno.Name := 'cdsItensprodcodigo_interno';
    cdsItensprodcodigo_interno.FieldName := 'prod.codigo_interno';
    cdsItensunidadesigla.SetParentComponent(cdsItens);
    cdsItensunidadesigla.Name := 'cdsItensunidadesigla';
    cdsItensunidadesigla.FieldName := 'unidade.sigla';
    cdsItensprodnome.SetParentComponent(cdsItens);
    cdsItensprodnome.Name := 'cdsItensprodnome';
    cdsItensprodnome.FieldName := 'prod.nome';
    dtsItens.SetParentComponent(Self);
    dtsItens.Name := 'dtsItens';
    dtsItens.DataSet := cdsItens;
    dtsItens.Left := 32;
    dtsItens.Top := 549;
    tmrConsultaItens.SetParentComponent(Self);
    tmrConsultaItens.Name := 'tmrConsultaItens';
    tmrConsultaItens.Enabled := False;
    SetEvent(tmrConsultaItens, Self, 'OnTimer', 'tmrConsultaItensTimer');
    tmrConsultaItens.Left := 152;
    tmrConsultaItens.Top := 549;
    cdsPagamentos.SetParentComponent(Self);
    cdsPagamentos.Name := 'cdsPagamentos';
    cdsPagamentos.EntitySetName := 'Pagamentos';
    cdsPagamentos.Connection := DMConnection.ApiConnection;
    cdsPagamentos.QueryTop := 10;
    cdsPagamentos.Left := 554;
    cdsPagamentos.Top := 514;
    cdsPagamentosvalor.SetParentComponent(cdsPagamentos);
    cdsPagamentosvalor.Name := 'cdsPagamentosvalor';
    cdsPagamentosvalor.FieldName := 'valor';
    cdsPagamentosvalor.DisplayFormat := '#,##0.00';
    cdsPagamentosdata.SetParentComponent(cdsPagamentos);
    cdsPagamentosdata.Name := 'cdsPagamentosdata';
    cdsPagamentosdata.FieldName := 'data';
    cdsPagamentosdata.DisplayFormat := 'dd/mm/yy';
    cdsPagamentosmodalidadenome.SetParentComponent(cdsPagamentos);
    cdsPagamentosmodalidadenome.Name := 'cdsPagamentosmodalidadenome';
    cdsPagamentosmodalidadenome.FieldName := 'modalidade.nome';
    cdsPagamentosapagardocumento.SetParentComponent(cdsPagamentos);
    cdsPagamentosapagardocumento.Name := 'cdsPagamentosapagardocumento';
    cdsPagamentosapagardocumento.FieldName := 'apagar.documento';
    SetEvent(cdsPagamentosapagardocumento, Self, 'OnGetText', 'cdsPagamentosapagardocumentoGetText');
    cdsPagamentosapagarparcela.SetParentComponent(cdsPagamentos);
    cdsPagamentosapagarparcela.Name := 'cdsPagamentosapagarparcela';
    cdsPagamentosapagarparcela.FieldName := 'apagar.parcela';
    dtsPagamentos.SetParentComponent(Self);
    dtsPagamentos.Name := 'dtsPagamentos';
    dtsPagamentos.DataSet := cdsPagamentos;
    dtsPagamentos.Left := 642;
    dtsPagamentos.Top := 514;
    dtsAPagar.SetParentComponent(Self);
    dtsAPagar.Name := 'dtsAPagar';
    dtsAPagar.DataSet := cdsAPagar;
    dtsAPagar.Left := 392;
    dtsAPagar.Top := 523;
    cdsAPagar.SetParentComponent(Self);
    cdsAPagar.Name := 'cdsAPagar';
    cdsAPagar.EntitySetName := 'Apagar';
    cdsAPagar.Connection := DMConnection.ApiConnection;
    cdsAPagar.Left := 328;
    cdsAPagar.Top := 515;
    cdsAPagardocumento.SetParentComponent(cdsAPagar);
    cdsAPagardocumento.Name := 'cdsAPagardocumento';
    cdsAPagardocumento.FieldName := 'documento';
    SetEvent(cdsAPagardocumento, Self, 'OnGetText', 'cdsAPagardocumentoGetText');
    cdsAPagardocumento.Size := 255;
    cdsAPagarvalor.SetParentComponent(cdsAPagar);
    cdsAPagarvalor.Name := 'cdsAPagarvalor';
    cdsAPagarvalor.FieldName := 'valor';
    cdsAPagarvalor.Required := True;
    cdsAPagarvalor.DisplayFormat := '#,##0.00';
    cdsAPagarsaldo.SetParentComponent(cdsAPagar);
    cdsAPagarsaldo.Name := 'cdsAPagarsaldo';
    cdsAPagarsaldo.FieldName := 'saldo';
    cdsAPagarsaldo.DisplayFormat := '#,##0.00';
    cdsAPagarpago.SetParentComponent(cdsAPagar);
    cdsAPagarpago.Name := 'cdsAPagarpago';
    cdsAPagarpago.FieldName := 'pago';
    cdsAPagarpago.DisplayFormat := '#,##0.00';
    cdsAPagaremissao.SetParentComponent(cdsAPagar);
    cdsAPagaremissao.Name := 'cdsAPagaremissao';
    cdsAPagaremissao.FieldName := 'emissao';
    cdsAPagaremissao.DisplayFormat := 'dd/mm/yy';
    cdsAPagarvencimento.SetParentComponent(cdsAPagar);
    cdsAPagarvencimento.Name := 'cdsAPagarvencimento';
    cdsAPagarvencimento.FieldName := 'vencimento';
    cdsAPagarvencimento.Required := True;
    cdsAPagarvencimento.DisplayFormat := 'dd/mm/yy';
    cdsAPagarparcela.SetParentComponent(cdsAPagar);
    cdsAPagarparcela.Name := 'cdsAPagarparcela';
    cdsAPagarparcela.FieldName := 'parcela';
    cdsAPagarparcela.Size := 255;
  finally
    lbid.AfterLoadDFMValues;
    lbfornecedores_id.AfterLoadDFMValues;
    lbcfop.AfterLoadDFMValues;
    lbmodelo.AfterLoadDFMValues;
    lbserie.AfterLoadDFMValues;
    lbemissao.AfterLoadDFMValues;
    lbentrada.AfterLoadDFMValues;
    lbvalor_base_icms.AfterLoadDFMValues;
    lbvalor_icms.AfterLoadDFMValues;
    lbvalor_icms_desonerado.AfterLoadDFMValues;
    lbvalor_base_st.AfterLoadDFMValues;
    lbvalor_st.AfterLoadDFMValues;
    lbvalor_ipi.AfterLoadDFMValues;
    lbvalor_pis.AfterLoadDFMValues;
    lbvalor_cofins.AfterLoadDFMValues;
    lbvalor_frete.AfterLoadDFMValues;
    lbvalor_seguro.AfterLoadDFMValues;
    lbvalor_outras.AfterLoadDFMValues;
    lbacrescimo.AfterLoadDFMValues;
    lbvalor_acrescimo.AfterLoadDFMValues;
    lbdesconto.AfterLoadDFMValues;
    lbvalor_desconto.AfterLoadDFMValues;
    lbvalor_itens.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    lbobs.AfterLoadDFMValues;
    lbchave_nfe.AfterLoadDFMValues;
    lbicms_compoe_base_pis_confins.AfterLoadDFMValues;
    lbipi_compoe_base_pis_cofins.AfterLoadDFMValues;
    lbfrete_compoe_base_pis_cofins.AfterLoadDFMValues;
    lbseguro_compoe_base_pis_cofins.AfterLoadDFMValues;
    lboutras_compoe_base_pis_cofins.AfterLoadDFMValues;
    lbplano_contas_id.AfterLoadDFMValues;
    lbplano_contas_contabil_id.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbPaginationInfoItens.AfterLoadDFMValues;
    lbPaginationInfoAPagar.AfterLoadDFMValues;
    lbPaginationInfoPagamentos.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edfornecedores_id.AfterLoadDFMValues;
    edcfop.AfterLoadDFMValues;
    edmodelo.AfterLoadDFMValues;
    edserie.AfterLoadDFMValues;
    edemissao.AfterLoadDFMValues;
    edentrada.AfterLoadDFMValues;
    edvalor_base_icms.AfterLoadDFMValues;
    edvalor_icms.AfterLoadDFMValues;
    edvalor_icms_desonerado.AfterLoadDFMValues;
    edvalor_base_st.AfterLoadDFMValues;
    edvalor_st.AfterLoadDFMValues;
    edvalor_ipi.AfterLoadDFMValues;
    edvalor_pis.AfterLoadDFMValues;
    edvalor_cofins.AfterLoadDFMValues;
    edvalor_frete.AfterLoadDFMValues;
    edvalor_seguro.AfterLoadDFMValues;
    edvalor_outras.AfterLoadDFMValues;
    edacrescimo.AfterLoadDFMValues;
    edvalor_acrescimo.AfterLoadDFMValues;
    eddesconto.AfterLoadDFMValues;
    edvalor_desconto.AfterLoadDFMValues;
    edvalor_itens.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    edobs.AfterLoadDFMValues;
    edchave_nfe.AfterLoadDFMValues;
    edplano_contas_id.AfterLoadDFMValues;
    edplano_contas_contabil_id.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxicms_compoe_base_pis_confins.AfterLoadDFMValues;
    cbxipi_compoe_base_pis_cofins.AfterLoadDFMValues;
    cbxfrete_compoe_base_pis_cofins.AfterLoadDFMValues;
    cbxseguro_compoe_base_pis_cofins.AfterLoadDFMValues;
    cbxoutras_compoe_base_pis_cofins.AfterLoadDFMValues;
    btnCopiarChaveAcesso.AfterLoadDFMValues;
    tblItens.AfterLoadDFMValues;
    cbPageSizeItens.AfterLoadDFMValues;
    edSearchItens.AfterLoadDFMValues;
    pnlItensPromocao.AfterLoadDFMValues;
    btnItensTab.AfterLoadDFMValues;
    lcPaginatorItens.AfterLoadDFMValues;
    pnlTabelaAReceber.AfterLoadDFMValues;
    tblAPagar.AfterLoadDFMValues;
    lcPaginatorAPagar.AfterLoadDFMValues;
    tblPagamentos.AfterLoadDFMValues;
    pnlTabelaPagamentos.AfterLoadDFMValues;
    btnFinanceiroTab.AfterLoadDFMValues;
    btnPagamentosTab.AfterLoadDFMValues;
    lcPaginatorPagamentos.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ComprasDataset.AfterLoadDFMValues;
    ComprasDatasetid.AfterLoadDFMValues;
    ComprasDatasetfornecedores_id.AfterLoadDFMValues;
    ComprasDatasetcfop.AfterLoadDFMValues;
    ComprasDatasetmodelo.AfterLoadDFMValues;
    ComprasDatasetserie.AfterLoadDFMValues;
    ComprasDatasetemissao.AfterLoadDFMValues;
    ComprasDatasetentrada.AfterLoadDFMValues;
    ComprasDatasetvalor_base_icms.AfterLoadDFMValues;
    ComprasDatasetvalor_icms.AfterLoadDFMValues;
    ComprasDatasetvalor_icms_desonerado.AfterLoadDFMValues;
    ComprasDatasetvalor_base_st.AfterLoadDFMValues;
    ComprasDatasetvalor_st.AfterLoadDFMValues;
    ComprasDatasetvalor_ipi.AfterLoadDFMValues;
    ComprasDatasetvalor_pis.AfterLoadDFMValues;
    ComprasDatasetvalor_cofins.AfterLoadDFMValues;
    ComprasDatasetvalor_frete.AfterLoadDFMValues;
    ComprasDatasetvalor_seguro.AfterLoadDFMValues;
    ComprasDatasetvalor_outras.AfterLoadDFMValues;
    ComprasDatasetacrescimo.AfterLoadDFMValues;
    ComprasDatasetvalor_acrescimo.AfterLoadDFMValues;
    ComprasDatasetdesconto.AfterLoadDFMValues;
    ComprasDatasetvalor_desconto.AfterLoadDFMValues;
    ComprasDatasetvalor_itens.AfterLoadDFMValues;
    ComprasDatasetvalor_total.AfterLoadDFMValues;
    ComprasDatasetobs.AfterLoadDFMValues;
    ComprasDatasetchave_nfe.AfterLoadDFMValues;
    ComprasDataseticms_compoe_base_pis_confins.AfterLoadDFMValues;
    ComprasDatasetipi_compoe_base_pis_cofins.AfterLoadDFMValues;
    ComprasDatasetfrete_compoe_base_pis_cofins.AfterLoadDFMValues;
    ComprasDatasetseguro_compoe_base_pis_cofins.AfterLoadDFMValues;
    ComprasDatasetoutras_compoe_base_pis_cofins.AfterLoadDFMValues;
    ComprasDatasetplano_contas_id.AfterLoadDFMValues;
    ComprasDatasetplano_contas_contabil_id.AfterLoadDFMValues;
    ComprasDatasetcodigo_interno.AfterLoadDFMValues;
    ComprasDatasetexcluido.AfterLoadDFMValues;
    ComprasDatasetinclusao.AfterLoadDFMValues;
    ComprasDatasetalteracao.AfterLoadDFMValues;
    ComprasDatasetexclusao.AfterLoadDFMValues;
    ComprasDatasetcfop_cfopnome.AfterLoadDFMValues;
    ComprasDatasetplano_contanome.AfterLoadDFMValues;
    ComprasDatasetplano_conta_contnome.AfterLoadDFMValues;
    ComprasDatasetfornecedorrazao_social_nome.AfterLoadDFMValues;
    XDataClientComprasGet.AfterLoadDFMValues;
    cdsItens.AfterLoadDFMValues;
    cdsItensitem.AfterLoadDFMValues;
    cdsItensproduto_nome.AfterLoadDFMValues;
    cdsItensquantidade.AfterLoadDFMValues;
    cdsItensvalor_unitario.AfterLoadDFMValues;
    cdsItensvalor_total.AfterLoadDFMValues;
    cdsItensprodcodigo_interno.AfterLoadDFMValues;
    cdsItensunidadesigla.AfterLoadDFMValues;
    cdsItensprodnome.AfterLoadDFMValues;
    dtsItens.AfterLoadDFMValues;
    tmrConsultaItens.AfterLoadDFMValues;
    cdsPagamentos.AfterLoadDFMValues;
    cdsPagamentosvalor.AfterLoadDFMValues;
    cdsPagamentosdata.AfterLoadDFMValues;
    cdsPagamentosmodalidadenome.AfterLoadDFMValues;
    cdsPagamentosapagardocumento.AfterLoadDFMValues;
    cdsPagamentosapagarparcela.AfterLoadDFMValues;
    dtsPagamentos.AfterLoadDFMValues;
    dtsAPagar.AfterLoadDFMValues;
    cdsAPagar.AfterLoadDFMValues;
    cdsAPagardocumento.AfterLoadDFMValues;
    cdsAPagarvalor.AfterLoadDFMValues;
    cdsAPagarsaldo.AfterLoadDFMValues;
    cdsAPagarpago.AfterLoadDFMValues;
    cdsAPagaremissao.AfterLoadDFMValues;
    cdsAPagarvencimento.AfterLoadDFMValues;
    cdsAPagarparcela.AfterLoadDFMValues;
  end;
end;

end.
